// src/lib/i18n/messages/es.ts
// Español. Mismas claves que fr.ts (lo verifica el tipo), mismas variables (lo verifican los tests).
// Redactado el 11/10/2026; a releer por un hablante nativo antes de activar el enrutamiento.

import type { Catalogue } from '../t';

export const es: Catalogue = {
  commun: {
    accueil: 'Inicio',
    acteurs: 'Actores',
    brouillon: 'Borrador',
    surDix: '{note}/10',
    citation: '«{texte}»',
    laSource: 'la fuente',
    ouvrirSource: 'Abrir la fuente',
    sansAdresse: 'sin enlace',
    nonEvalueCourt: 'n.e.',
    essentiel: 'Lo esencial en 30 segundos',
    portraitDe: 'Retrato de {nom}',
    photo: 'Foto',
  },

  ia: {
    long: 'Los análisis de Lumière Noire se elaboran con modelos de inteligencia artificial que aplican un protocolo idéntico a todos los temas, y después son revisados y validados por una persona antes de su publicación. Se basan en fuentes públicas citadas. Pueden contener errores o imprecisiones: constituyen un análisis, no una verdad judicial ni un hecho probado. Toda persona afectada puede solicitar una corrección o ejercer su derecho de réplica.',
    court: 'Análisis elaborado con ayuda de la IA y revisado por la redacción.',
    methodologie: 'Metodología',
    signaler: 'Señalar un error / derecho de réplica',
  },

  traduction: {
    auto: 'Traducido automáticamente del francés.',
    original: 'Leer el original',
    aRelire: 'Traducción pendiente de revisión: visible solo para los administradores hasta su publicación.',
    perimee: 'Traducción desactualizada: el francés ha cambiado desde entonces. Visible solo para los administradores.',
    absente: 'Este contenido aún no está traducido: se muestra en su idioma original.',
    section: 'Esta sección solo está disponible en francés por ahora.',
  },

  pdf: {
    reserveAbonnes: 'La exportación en PDF está reservada a los suscriptores',
    abonnes: 'PDF · suscriptores',
    telecharger: 'Descargar este análisis en PDF, a su nombre',
    preparation: 'Preparando…',
    exporter: 'Exportar en PDF',

    doc: {
      sommaire: 'Índice',
      sources: 'Fuentes',
      source: 'Fuente',
      sourceSansTitre: 'Fuente sin título',
      version: 'versión {n}',
      brouillon: 'borrador',
      nonPublie: 'no publicado',
      filigrane: 'Exportado por {nom} el {date} · Lumière Noire',
      unAbonne: 'un suscriptor',
      retenir: 'Lo que hay que retener',
      dansCeDocument: 'En este documento',
      note: 'Nota',
      pied: {
        avecVersion: '{genre} del {date}, v{version}',
        sansVersion: '{genre} del {date}',
        sansDate: '{genre} v{version}',
      },
      genres: {
        analyse: 'Análisis',
        barometre: 'Barómetro',
        rayonx: 'RayonX',
        organisation: 'Ficha',
        acteur: 'Ficha',
      },
      produit: {
        analyse: 'Análisis elaborado el {date}',
        barometre: 'Barómetro elaborado el {date}',
        rayonx: 'RayonX elaborado el {date}',
        organisation: 'Ficha elaborada el {date}',
        acteur: 'Ficha actualizada el {date}',
      },
      sansDate: {
        analyse: 'Análisis',
        barometre: 'Barómetro',
        rayonx: 'RayonX',
        organisation: 'Ficha de organización',
        acteur: 'Ficha de actor',
      },
      couvertJusquau: 'hechos cubiertos hasta el {date}',
      confiance: {
        high: 'confianza alta',
        medium: 'confianza media',
        low: 'confianza baja',
      },
    },

    analyse: {
      kicker: 'Análisis',
      contexte: 'Contexto',
      perspective: 'Perspectiva: {label}',
      sansTitre: 'sin título',
      pointsCles: 'Puntos clave',
      appuie: 'Lo que la respalda',
      contredit: 'Lo que la contradice',
      limites: 'Sus límites',
      faits: 'Hechos establecidos',
      contestePar: 'Cuestionado por',
      chronologie: 'Cronología',
      comparaisons: 'Comparaciones históricas',
      ressemblances: 'Similitudes',
      differences: 'Diferencias',
      lecons: 'Lecciones',
      scenarios: 'Escenarios',
      probabilite: 'probabilidad {n} %',
      probabiliteSuivie: 'probabilidad {n} % (en el análisis: {initiale} %, revisada el {date})',
      declencheurs: 'Detonantes',
      consequences: 'Consecuencias',
      impact: 'Impacto en la ciudadanía',
      resonance: 'Resonancia social',
      sentiments: 'Sentimientos dominantes',
      recitsEmergents: 'Relatos emergentes',
      manipulation: 'Señales de manipulación',
    },

    barometre: {
      conclusions: 'Conclusiones clave',
      pointsAttention: 'Puntos de atención',
      justification: 'Justificación de la evaluación',
      schema: 'Patrón recurrente',
      facteurs: 'Factores de contexto',
      engagements: 'Compromisos — {domaine}',
      execution: 'ejecución {note}/10',
      franchise: 'franqueza {note}/10',
      declaration: 'Declaración — nada que ejecutar',
      nonEvaluable: 'No evaluable (demasiado vago para medirse)',
      passe: 'Lo que ocurrió',
      neDisaitPas: 'Lo que la promesa no decía',
      noteFranchise: 'Nota de franqueza',
      nonTenus: 'No cumplidos',
      tenus: 'Cumplidos',
      partiels: 'Cumplidos en parte',
      declarations: 'Declaraciones',
      nonTenusSur: { one: '{n} compromiso no cumplido de {total}', other: '{n} compromisos no cumplidos de {total}' },
      trahisSur: { one: '{n} compromiso traicionado de {total}', other: '{n} compromisos traicionados de {total}' },
      aucunEvaluable: 'Ningún compromiso evaluable',
      executionLibelle: 'Ejecución',
      franchiseLibelle: 'Franqueza',
      etatDeclaration: 'Declaración',
      etatNonEvaluable: 'No evaluable',
      declarationPrecision: 'Nada que ejecutar: solo se califica la franqueza.',
      nonEvaluablePrecision: 'Demasiado vago para medirse.',
      methode: 'Dos notas, separadas. La ejecución mide lo que se hizo; la franqueza, lo que se dijo de los costes y las renuncias. Una declaración solo tiene la segunda.',
    },

    rayonx: {
      affirmation: 'La afirmación',
      verdict: 'El veredicto',
      vrai: 'Lo que es verdad',
      faux: 'Lo que es falso o falta',
      sousAffirmations: 'Las subafirmaciones',
      pointsCles: 'Puntos clave',
      confirme: 'Lo que confirma',
      refute: 'Lo que refuta',
      nuance: 'Lo que matiza',
      reserves: 'Salvedades',
      preuves: 'Las pruebas, una por una',
      preuve: 'Prueba {n}',
      score: 'Puntuación del veredicto',
      pourOui: 'Pruebas a favor del sí',
      pourNon: 'Pruebas a favor del no',
      confirment: 'Pruebas que confirman',
      refutent: 'Pruebas que refutan',
      nuancent: 'Pruebas que matizan',
      sansVerdict: 'Sin veredicto',
      polarite: {
        confirms: 'confirma',
        refutes: 'refuta',
        nuance: 'matiza',
      },
      poids: {
        p1: 'peso bajo',
        p2: 'peso moderado',
        p3: 'peso alto',
      },
    },

    organisation: {
      kicker: 'Organización',
      essentiel: 'Lo esencial',
      quoi: '¿Qué es?',
      fondee: 'fundada en {date}',
      siege: 'sede: {lieu}',
      budget: 'presupuesto: {montant}',
      ditDElle: 'Lo que dice de sí misma',
      poursuit: 'Lo que persigue',
      origine: 'De dónde viene',
      evolution: 'Su evolución',
      pays: 'Países donde opera',
      qui: '¿Quién forma parte?',
      categories: {
        politicalLeaders: 'Responsables políticos',
        corporateLeaders: 'Directivos de empresa',
        financialSector: 'Finanzas',
        mediaProfessionals: 'Medios',
        academicIntellectuals: 'Académicos e intelectuales',
        internationalOrganizations: 'Organizaciones internacionales',
        militaryDefense: 'Defensa',
      },
      invites: {
        strategicInvitees: 'Invitados estratégicos',
        cooptedOpponents: 'Opositores cooptados',
        emergingLeaders: 'Líderes emergentes',
      },
      invite: 'invitado en {annee}',
      pese: '¿Cómo influye en las decisiones?',
      recos: 'Recomendaciones que surtieron efecto',
      crises: 'Crisis previstas',
      evoquee: 'mencionada: {date}',
      survenue: 'ocurrida: {date}',
      rdvDecisions: 'Citas y decisiones',
      rdv: 'Las citas',
      argent: '¿De dónde viene el dinero?',
      quiFinance: 'Quién la financia',
      circuit: 'Un circuito de financiación circular',
      conflits: 'Conflictos de intereses',
      transparence: 'Transparencia',
      scoreTransparence: 'Puntuación de transparencia: {n}/100.',
      travaille: '¿Con quién trabaja?',
      orgsLiees: 'Organizaciones vinculadas',
      membresPartages: '({n} miembros compartidos)',
      casquettes: 'Miembros con varios sombreros',
      reseau: 'La red',
      retenir: '¿Qué hay que retener?',
      verdict: 'Veredicto',
      constats: 'Constataciones clave',
      probleme: 'Lo que plantea problemas',
      legitimes: 'Contribuciones legítimas',
      ouvert: '¿Qué queda abierto?',
      fiabilite: 'Fiabilidad de las fuentes',
      pasEtabli: 'Lo que la ficha no pudo establecer',
      pistes: 'Pistas de investigación',
      membresDocumentes: 'Miembros documentados',
      rendezVous: 'Citas',
    },

    acteur: {
      kicker: 'Ficha de actor',
      biographie: 'Biografía',
      parolesActes: 'Palabras y hechos',
      barometreVersion: 'Barómetro, versión {n}',
      noteFranchise: 'nota de franqueza {note}/10',
      conclusions: 'Conclusiones clave',
      barometreComplet: 'El barómetro completo: {url}',
      investigation: 'Investigación',
      investigationComplete: 'La investigación completa: {url}',
      rayonx: 'RayonX',
      positions: 'Posiciones públicas',
      position: 'Posición',
      appartenances: 'Pertenencias',
      relations: 'Relaciones',
      evenements: 'Eventos',
      analyses: 'En los análisis',
      organisations: 'Organizaciones',
      noteDeFranchise: 'Nota de franqueza',
      essentiel: 'Palabras y hechos: {accroche}.',
      roles: {
        speaker: 'ponente',
        attendee: 'participante',
        organizer: 'organizador',
        moderator: 'moderador',
        observer: 'observador',
      },
    },
  },

  bs: {
    famille: 'Palabras y hechos',

    profils: {
      libelles: {
        "techno-illusionniste": "Complejidad técnica elevada",
        "promesses-saturateur": "Inflación de compromisos",
        "chaos-assume": "Incoherencia de posiciones",
        "economie-fiction": "Proyecciones presupuestarias optimistas",
        "transferts-masques": "Transferencia de carga no explicitada",
        "techno-pragmatique": "Pragmatismo variable",
        "hypocrite-moral": "Desfase entre discurso y conducta",
        "merite-emprunte": "Causas externas no reconocidas",
        "statisticien-creatif": "Indicador redefinido sobre la marcha",
        "perimetre-glissant": "Alcance reducido sobre la marcha",
        "aucun": "Ningún patrón recurrente identificado"
      },
      descriptions: {
        "techno-illusionniste": "Recurso marcado a argumentos técnicos, en detrimento de la legibilidad de las contradicciones de fondo.",
        "promesses-saturateur": "Multiplicación de compromisos que dificulta el seguimiento de lo realizado.",
        "chaos-assume": "Posiciones contradictorias sucesivas o simultáneas que dificultan la evaluación.",
        "economie-fiction": "Proyecciones presupuestarias poco fundamentadas presentadas como realistas.",
        "transferts-masques": "Desplazamiento de cargas fiscales o sociales sin comunicación explícita.",
        "techno-pragmatique": "Revisión de compromisos ante restricciones institucionales o políticas.",
        "hypocrite-moral": "Desfase documentado entre los valores proclamados y la conducta observada.",
        "merite-emprunte": "Resultados favorables presentados como fruto de la acción, sin mencionar los factores que contribuyeron a ellos.",
        "statisticien-creatif": "Objetivo presentado como alcanzado tras modificar la regla de medición.",
        "perimetre-glissant": "Objetivo presentado como alcanzado tras reducir lo que abarcaba.",
        "aucun": "Ningún patrón sistémico identificado en los compromisos analizados."
      },
    },

    regle: {
      noteGlobale: 'nota global {note}',
      contredit: 'contradicho por los hechos',
      tenu: 'cumplido',
    },

    echelle: {
      nonEvalue: 'Sin evaluar',
      majeurs: 'Desfases graves documentados',
      significatifs: 'Desfases importantes observados',
      partielle: 'Coherencia parcial',
      solide: 'Coherencia sólida',
      elevee: 'Coherencia elevada',
    },

    page: {
      introuvable: 'Análisis no encontrado',
      voirToutes: '← Ver todos los análisis',
      angleCible: 'Enfoque · {angle}',
      engagementsDe: 'Compromisos de {nom}',
      nbEngagements: { one: '{n} compromiso', other: '{n} compromisos' },
      verdictEnCinq: 'El veredicto en 5 minutos ↓',
      unParUn: { one: 'El compromiso, en detalle ↓', other: 'Los {n} compromisos, uno por uno ↓' },
      pied: 'Lumière Noire · Análisis de coherencia · {nom}',
    },

    onglets: {
      verdict: 'Veredicto',
      engagements: 'Compromisos',
    },

    verdict: {
      repartition: 'Distribución de las puntuaciones',
      quantifiables: 'Compromisos cuantificables',
      qualitatifs: 'Compromisos cualitativos',
      nonEvaluables: {
        one: '{n} compromiso no evaluable (formulación demasiado imprecisa)',
        other: '{n} compromisos no evaluables (formulación demasiado imprecisa)',
      },
      conclusions: 'Conclusiones clave',
      pointsAttention: 'Puntos de atención',
      justification: 'Justificación de la evaluación',
      schemaRecurrent: 'Patrón recurrente — análisis detallado',
      facteurs: 'Factores de contexto',
    },

    liste: {
      avertissement: 'Selección representativa de compromisos públicos. No exhaustiva. Cada evaluación se basa en hechos documentados y con fuentes.',
      moyenne: 'media {note}',
      titreNonEvaluable: 'Compromiso demasiado vago para medirse: no evaluable',
      titreDeclaration: 'Declaración: nada que ejecutar, la nota es la de la franqueza',
      badgeDeclaration: 'declaración · franqueza',
    },

    domaines: {
      economie_emploi: 'Economía',
      social_sante: 'Social / Salud',
      securite_immigration: 'Seguridad',
      environnement_energie: 'Medio ambiente',
      international_defense: 'Internacional',
      institutions_democratie: 'Instituciones',
    },

    classification: {
      quantifiable: 'cuantificable',
      qualitative: 'cualitativo',
      floue: 'vago',
    },

    tenue: {
      tenu: 'Cumplido',
      partiel: 'Cumplido en parte',
      non_tenu: 'No cumplido',
    },

    carte: {
      declarationRien: 'Declaración · nada que ejecutar',
      franchise: 'franqueza {note}/10',
      deuxAxes: 'ejecución {tenue}/10 · franqueza {franchise}/10',
      dit: 'LO QUE SE DIJO',
      passe: 'LO QUE OCURRIÓ',
      neDisaitPas: 'LO QUE LA PROMESA NO DECÍA',
      sourcesDisent: 'LO QUE DICEN LAS FUENTES',
      lecture: 'NUESTRA LECTURA',
      passage: 'el pasaje',
      motPourMot: 'Cada hecho se encuentra palabra por palabra en su página.',
      sources: { one: 'La fuente', other: 'Las {n} fuentes' },
      analyse: 'El análisis detallado',
      poids: 'Cuánto pesa en la nota',
      primaireNonEtablie: 'Fuente primaria no establecida: la cifra o el acto solo aparece citado aquí por medios de comunicación, sin el organismo que lo produce.',
      emetteur: 'Emisor: {emetteur}',
      sourceN: 'Fuente {n}',
      quiPaie: 'QUIÉN PAGA REALMENTE',
      payeurs: 'Pagadores: {payeurs} · Beneficiarios: {beneficiaires}',
      ecartStat: 'DESFASE ESTADÍSTICO · {gravite}',
      dissonance: 'DISONANCIA OBSERVADA',
    },

    pastilles: {
      budget: 'Presupuesto',
      couts: 'Costes',
      clarte: 'Claridad de la definición',
      coherence: 'Coherencia declarativa',
      stabilite: 'Estabilidad en el tiempo',
      masquer: 'Ocultar el motivo',
      voir: 'Ver por qué',
      pourquoi: '{libelle}: {valeur} — por qué',
      valeurs: {
        realiste: 'realista',
        optimiste: 'optimista',
        fantaisiste: 'fantasioso',
        impossible: 'imposible',
        assume: 'asumido',
        minimise: 'minimizado',
        deni: 'negado',
        fiction: 'ficción',
        oui: 'sí',
        floue: 'vaga',
        inexistante: 'inexistente',
        coherent: 'coherente',
        contradictoire: 'contradictoria',
        opportuniste: 'oportunista',
        stable: 'estable',
        evolutive: 'cambiante',
        reniee: 'renegada',
      },
    },

    notation: {
      deuxMesures: 'Dos medidas, y no coinciden',
      tenueTermes: 'Cumplido en sus propios términos',
      sinceriteReserves: 'Sinceridad, descontadas las reservas',
      retientSeconde: 'El barómetro se queda con la segunda: alcanzar un objetivo desplazando el problema, o cambiando la regla de cálculo, no es cumplirlo.',
      reservesDocumentees: { one: '{n} reserva documentada', other: '{n} reservas documentadas' },
      poidsTitre: 'Peso de este compromiso en la nota · ×{total}',
      pouvoir: 'Poder ostentado — {valeur}',
      verifiabilite: 'Verificabilidad — {valeur}',
      chiffre: 'compromiso cifrado',
      appreciable: 'valorable',
      centralite: 'Centralidad — {valeur}',
      nonRetenue: ' · no reconocida: {motif}',
      reserves: {
        transfert_de_charge: 'transferencia de la carga',
        definition_indicateur: 'definición del indicador modificada',
        perimetre_restreint: 'alcance reducido',
        causalite_non_reconnue: 'causalidad no reconocida',
        financement_non_assume: 'financiación no asumida',
      },
      pouvoirs: {
        fonction_et_moyens: 'cargo y medios a su alcance',
        fonction_sans_moyens: 'cargo sin los medios',
        candidat_elu: 'candidato, después elegido',
        candidat_battu: 'candidato, no elegido',
        aucun_levier: 'ninguna palanca sobre el asunto',
      },
      centralites: {
        programme_repete: 'promesa de programa, repetida',
        engagement_assume: 'compromiso público asumido',
        propos_de_circonstance: 'declaración de circunstancias',
      },
      motifs: {
        moins_de_deux_occurrences_datees: 'menos de dos apariciones fechadas',
        aucune_occurrence_sourcee: 'ninguna aparición respaldada por un enlace',
      },
    },

    profil: {
      phrasesReserve: {
        transfert_de_charge: 'un objetivo alcanzado desplazando la carga hacia otros',
        financement_non_assume: 'un gasto anunciado sin decir quién lo paga',
        definition_indicateur: 'un objetivo alcanzado tras cambiar la regla de medición',
        perimetre_restreint: 'un objetivo alcanzado tras reducir lo que abarcaba',
        causalite_non_reconnue: 'resultados favorables presentados como fruto de la acción, sin mencionar lo que contribuyó a ellos',
      },
      aucuneReserve: {
        one: 'De {n} compromiso evaluable, ninguna reserva documentada: los desfases constatados son contradicciones directas, sin transferencia de carga, cambio de definición ni reducción del alcance.',
        other: 'De {n} compromisos evaluables, ninguna reserva documentada: los desfases constatados son contradicciones directas, sin transferencia de carga, cambio de definición ni reducción del alcance.',
      },
      avecReserve: {
        one: 'De los {total} compromisos, {n} va acompañado de una reserva.',
        other: 'De los {total} compromisos, {n} van acompañados de una reserva.',
      },
      laPlusFrequente: 'La más frecuente, {fois}: {phrase}.',
      ensuite: 'Le sigue, {fois}, {phrase}.',
      fois: { one: 'una vez', other: '{n} veces' },
    },
  },

  nav: {
    brief: 'El Brief',
    analyses: 'Análisis',
    rayonx: 'RayonX',
    acteurs: 'Actores',
    organisations: 'Organizaciones',
    enquetes: 'Investigaciones',
    monQg: 'Mi cuartel',
    evitement: 'Ir al contenido principal',
    premium: 'Reservado a los suscriptores Premium',
    rechercherRaccourci: 'Buscar (Ctrl+K)',
    rechercherPoints: 'Buscar…',
    deconnexion: 'Cerrar sesión',
    connexion: 'Iniciar sesión',
    fermerMenu: 'Cerrar el menú',
    menu: 'Menú',
    modeClair: 'Cambiar al modo claro',
    modeSombre: 'Cambiar al modo oscuro',
  },

  pied: {
    explorer: 'Explorar',
    liensLegaux: 'Enlaces legales',
    actu: 'Actualidad',
    graphe: 'El Grafo',
    about: 'Acerca de',
    methodologie: 'Metodología',
    mentions: 'Aviso legal',
    confidentialite: 'Privacidad',
    corrections: 'Correcciones y derecho de réplica',
    credits: 'Créditos fotográficos',
  },

  recherche: {
    titre: 'Buscar',
    champ: 'Una persona, una organización, un tema…',
    fermer: 'Cerrar',
    echap: 'Esc',
    resultats: 'Resultados',
    allerA: 'Ir directamente a',
    rien: 'Nada para «{requete}».',
    conseil: 'Compruebe la ortografía o pruebe solo con un apellido.',
    nbResultats: { one: '{n} resultado', other: '{n} resultados' },
    touches: '↑ ↓ para elegir · Intro para abrir',
    types: {
      actor: 'Actores',
      organization: 'Organizaciones',
      analysis: 'Análisis',
      investigation: 'Investigaciones',
    },
    raccourcis: {
      brief: 'El Brief del día',
      analyses: 'Los análisis',
      acteurs: 'Los actores',
      organisations: 'Las organizaciones',
      rayonx: 'Los RayonX',
      enquetes: 'Las investigaciones',
    },
  },

  ui: {
    lireLaSuite: 'Seguir leyendo →',
    reduire: '↑ Mostrar menos',
  },

  suite: {
    titre: '¿Y después?',
    sousTitre: 'El hilo continúa en otras investigaciones.',
    familles: {
      barometre: 'Palabras y hechos',
      investigation: 'Investigación',
      organisation: 'Red',
      anatomie: 'Anatomía',
      analyse: 'Análisis',
      rayonx: 'RayonX',
    },
  },

  parcours: {
    baroTitre: '{nom}: palabras y hechos',
    baroLien: 'Sus compromisos frente a lo que se hizo',
    invTitre: 'Investigación: {nom}',
    invLien: 'Trayectoria, redes, zonas de sombra',
    membre: '{nom} es miembro',
    citeeIci: 'Citada en esta página',
    figure: '{nom} aparece en ella',
    acteurDansAnalyse: '{nom} es uno de sus actores',
    affirmation: 'Una afirmación sobre {nom}, verificada',
    orgDansAnalyse: '{nom} aparece citada',
  },

  accueil: {
    titreDebut: 'Comprender para no',
    titreFin: 'padecer.',
    chapeau: 'Entre los medios que dan vueltas a lo mismo y los sitios que ven conspiraciones por todas partes, faltaba un espacio riguroso. Hechos con fuentes, contradicciones documentadas, redes cartografiadas. Sus conclusiones.',
    lireBrief: 'Leer el Brief del día →',
    parOuCommencer: '¿Por dónde empezar?',
    aLaUne: 'En portada',
    aVousDeJuger: 'Juzgue usted',
    vedette: 'El protagonista del día',
    tousActeurs: 'Todos los actores →',
    tousDossiers: 'Todos los expedientes →',
    trackRecord: 'Todo el historial →',
    voirGraphe: 'Ver el grafo →',
    toutesOrgs: 'Todas las organizaciones →',
    precedent: 'Anterior',
    suivant: 'Siguiente',
    voirElement: 'Ver {nom}',
    aLirePlusTard: 'Para leer más tarde',
    enregistreCourt: 'guardado para más tarde',
    enregistreLong: 'lo que guardó para profundizar en pantalla grande',
    reprendre: 'Retomar →',
    retirer: 'Quitar',
    bilan: {
      confirmed: { one: 'confirmado', other: 'confirmados' },
      partially_confirmed: { one: 'en parte', other: 'en parte' },
      invalidated: { one: 'invalidado', other: 'invalidados' },
      pending: { one: 'en curso', other: 'en curso' },
      sansTri: { one: 'Nuestro balance completo, sin filtrar: {n} escenario invalidado incluido.', other: 'Nuestro balance completo, sin filtrar: {n} escenarios invalidados incluidos.' },
    },
    conversion: {
      fermer: 'Cerrar',
      badge: 'Cuenta gratuita · 30 segundos',
      accrocheDebut: 'Lumière Noire va más allá',
      accrocheFin: 'cuando le conoce.',
      sauvegarder: 'Guarde análisis y perfiles en Mi cuartel',
      soumettre: 'Proponga temas, vote las sugerencias',
      creer: 'Crear una cuenta gratuita →',
      dejaCompte: '¿Ya tiene cuenta? Inicie sesión',
    },
  },

  types: {
    acteurs: {
      head_of_state: 'Jefe de Estado',
      minister: 'Ministro',
      politician: 'Figura política',
      party_leader: 'Líder de partido',
      diplomat: 'Diplomático',
      corporate_executive: 'Directivo empresarial',
      businessman: 'Empresario',
      banker: 'Banquero / Financiero',
      lobbyist: 'Lobista',
      military: 'Militar',
      intelligence: 'Inteligencia',
      magistrate: 'Magistrado',
      journalist: 'Periodista',
      media_owner: 'Propietario de medios',
      academic: 'Académico / Experto',
      ngo_leader: 'Responsable de ONG',
      union_leader: 'Sindicalista',
      activist: 'Activista / Sociedad civil',
      religious_leader: 'Líder religioso',
      oligarch: 'Oligarca',
      business: 'Empresario',
      company: 'Empresa',
      institution: 'Institución',
      media: 'Medio de comunicación',
      lobby: 'Lobby',
      ngo: 'Responsable de ONG',
    },
    organisations: {
      think_tank: 'Think tank',
      forum: 'Foro',
      club: 'Club / Círculo',
      lobby: 'Lobby / Grupo de presión',
      foundation: 'Fundación',
      ngo: 'ONG',
      union: 'Sindicato',
      political_party: 'Partido político',
      religious: 'Organización religiosa',
      corporation: 'Empresa privada',
      state_company: 'Empresa pública',
      bank: 'Banco / Institución financiera',
      media: 'Grupo mediático',
      intergovernmental: 'Organización intergubernamental',
      military: 'Organización militar / Alianza',
      intelligence: 'Servicio de inteligencia',
      university: 'Universidad / Institución académica',
      unknown: 'Sin clasificar',
    },
  },

  verdicts: {
    libelles: {
      vrai: 'Verdadero',
      'plutôt_vrai': 'Más bien verdadero',
      partiellement_vrai: 'Parcialmente verdadero',
      'plutôt_faux': 'Más bien falso',
      faux: 'Falso',
      'non_vérifiable': 'No verificable',
    },
    reponses: {
      vrai: 'Sí',
      'plutôt_vrai': 'Probablemente sí',
      partiellement_vrai: 'En parte',
      'plutôt_faux': 'Probablemente no',
      faux: 'No',
      'non_vérifiable': 'Imposible saberlo',
    },
    issues: {
      confirmed: 'Confirmado',
      partially_confirmed: 'Confirmado en parte',
      invalidated: 'Invalidado',
      pending: 'En evolución',
    },
  },

  familles: {
    analyse: 'Análisis',
    barometre: 'Barómetro de coherencia',
    parolesEtActes: 'Palabras y hechos',
    rayonx: 'RayonX',
    anatomie: 'Anatomía',
    loupe: 'Lupa',
    investigation: 'Investigación',
    organisation: 'Organización',
    dossier: 'Expediente',
    acteur: 'Actor',
    thematique: 'Temática',
    scenario: 'Escenario',
    declaration: 'Declaración',
  },

  home: {
    dernieresDepeches: 'Los últimos despachos',
    leBrief: 'El Brief →',
    touteActu: 'Toda la actualidad →',
    critique: 'Crítico',
    comprendre: 'Entender: {famille} {titre} →',
    depuisVisite: 'Desde su última visita',
    nbDepeches: { one: '{n} despacho →', other: '{n} despachos →' },
    nbPublications: { one: '{n} publicación', other: '{n} publicaciones' },
    publicationsDepuis: { one: '{n} publicación desde el {date}', other: '{n} publicaciones desde el {date}' },
    vraiOuFaux: '¿Verdadero o falso?',
    votreAvis: '¿Qué opina?',
    aVotreAvis: '¿Usted qué cree?',
    bienVu: 'Bien visto.',
    pasCetteFois: 'Esta vez no.',
    voirVerification: 'Ver la verificación y sus fuentes →',
    declarationKicker: 'Palabras y hechos · Declaración',
    coherentsQuestion: 'Palabras y hechos: ¿coherentes?',
    voirSesEngagements: 'Ver sus {n} compromisos frente a los hechos →',
    reponses: {
      vrai: 'Verdadero',
      nuance: 'Matizado',
      faux: 'Falso',
      coherents: 'Coherentes',
      en_partie: 'En parte',
      contredits: 'Contradichos',
    },
    engagement: {
      coherents: 'Palabras y hechos coherentes',
      en_partie: 'Coherentes en parte',
      contredits: 'Palabras contradichas por los hechos',
    },
    notesGlobales: 'Las notas globales de los barómetros',
    questions: {
      promesses: {
        titre: '¿Quién cumple sus promesas?',
        texte: 'Los compromisos de los responsables públicos, frente a lo que hicieron.',
      },
      verifications: {
        titre: '¿Es verdad que…?',
        texte: 'Afirmaciones que circulan, pasadas por el tamiz de las fuentes.',
      },
      reseaux: {
        titre: '¿Quién se codea con quién?',
        texte: 'Qué son estos círculos, hasta dónde llega su influencia y quién forma parte de ellos.',
      },
      avenir: {
        titre: '¿Cómo orientarse?',
        texte: 'Cada tema leído desde varios ángulos, con fuentes, hasta sus posibles consecuencias.',
      },
      enquetes: {
        titre: 'Profundicemos',
        texte: 'Sistemas, casos, trayectorias: examinados en detalle, con fuentes.',
      },
    },
    pasIci: 'Lo que no encontrará aquí: certezas disfrazadas de hechos, ni conclusiones que vayan más allá de lo que permiten las pruebas.',
    notreMethode: 'Leer nuestro método →',
    trackRecord: 'Todo el historial →',
    aBouge: 'Lo que ha cambiado',
    scenariosRevusRecemment: 'Escenarios revisados recientemente',
    scenariosRevus: 'escenarios revisados',
    revusFaits: 'Nuestros escenarios, revisados a la luz de los hechos',
    enHausse: 'al alza',
    enBaisse: 'a la baja',
    tuiles: {
      nbEngagementsActes: 'Los {n} compromisos frente a los hechos →',
      lireBarometre: 'Leer el barómetro →',
      leBarometre: 'El barómetro',
      dossierKicker: 'Expediente · {ancre}',
      metaAnalyse: ' · metaanálisis',
      leDossier: 'El expediente',
      scenarioKicker: 'Escenario · {sujet}',
      analyseMin: 'análisis',
      lAnalyse: 'El análisis',
      lAnalyseFleche: 'El análisis →',
      siegePartout: 'Está en todas partes',
      organisations: 'organizaciones',
      leProfil: 'El perfil',
      membresCommun: 'Miembros en común',
      membresCommunsEntre: '{n} miembros comunes entre {a} y {b}',
      auMoins: 'Al menos {n} personas forman parte de ambas',
      dont: ', entre ellas {noms}',
      deConsensus: 'de consenso',
      consensusLectures: 'Consenso entre las lecturas',
      laFiche: 'La ficha',
      lEnquete: 'La investigación',
      toucherReveler: 'Toque para revelar el veredicto',
      verdictPreuves: 'El veredicto y sus pruebas →',
    },
  },

  decouverte: {
    promesses: '{p} personalidades, {e} compromisos frente a los hechos',
    verifications: { one: '{n} afirmación verificada, con fuentes', other: '{n} afirmaciones verificadas, con fuentes' },
    reseaux: '{n} organizaciones analizadas',
    reseauxCumul: ', {n} personas en varias de ellas',
    membresDocumentes: '{nom} · {n} miembros documentados',
    sujets: '{n} temas analizados',
    scenariosDates: ', {n} escenarios fechados',
    anatomies: { one: '{n} anatomía de sistema', other: '{n} anatomías de sistema' },
    loupes: { one: '{n} lupa sobre casos', other: '{n} lupas sobre casos' },
    investigations: { one: '{n} investigación', other: '{n} investigaciones' },
    enquetesFond: 'investigaciones de fondo publicadas',
    titreAvenir: '{noms}… ¿cómo orientarse?',
    titreReseaux: '{noms}… ¿qué son y quién forma parte?',
  },

  relie: {
    analysis: 'Análisis',
    investigation: 'Investigación',
    bs: 'Coherencia',
    organisation: 'Cartografía',
  },

  signes: {
    balance: {
      confirme: { one: '{n} confirma', other: '{n} confirman' },
      nuance: { one: '{n} matiza', other: '{n} matizan' },
      refute: { one: '{n} refuta', other: '{n} refutan' },
      pourOui: '{n} a favor del sí',
      pourNon: '{n} a favor del no',
      preuves: '{n} pruebas: {detail}',
      voirOui: 'Ver las pruebas que apuntan al sí',
      voirNon: 'Ver las pruebas que apuntan al no',
      voirConfirment: 'Ver las pruebas que confirman',
      voirNuancent: 'Ver las pruebas que matizan',
      voirRefutent: 'Ver las pruebas que refutan',
    },
    calendrier: {
      scenariosDates: '{n} escenarios fechados',
      point: '{titre}: {p} %, vencimiento {echeance}',
    },
    constellation: {
      aria: '{n} miembros por sector',
      dont: ', entre ellos {noms}',
    },
    pouls: {
      aria: '{total} despachos en {semaines} semanas, {critiques} de ellos críticos',
      semaine: { one: 'Semana del {debut}: {n} despacho', other: 'Semana del {debut}: {n} despachos' },
      dontCritiques: { one: ', {n} crítico', other: ', {n} críticos' },
      legende: 'Una barra por semana, según la fecha del suceso',
      critiques: 'de ellos críticos',
    },
    maillage: {
      aria: { one: '{n} persona está en varias organizaciones', other: '{n} personas están en varias organizaciones' },
      barre: { one: '{n} persona en {k} organizaciones', other: '{n} personas en {k} organizaciones' },
      legende: { one: '{n} persona en varias organizaciones, por número de organizaciones', other: '{n} personas en varias organizaciones, por número de organizaciones' },
    },
    calendrierCouverture: { one: '{n} escenario fechado por venir · más alto, más probable', other: '{n} escenarios fechados por venir · más alto, más probable' },
    presence: {
      aria: 'Presencia en las {total} subinvestigaciones',
      ligne: { one: '{nom}: {n} subinvestigación de {total}', other: '{nom}: {n} subinvestigaciones de {total}' },
      legende: 'presencia en las {total} subinvestigaciones',
    },
    regle: 'Regla de las promesas',
  },

  temps: {
    aVenir: 'Próximamente',
    aujourdhui: 'Hoy',
    hier: 'Ayer',
    ilYa: { one: 'Hace {n} día', other: 'Hace {n} días' },
  },

  importance: {
    critical: 'Crítico',
    high: 'Importante',
    medium: 'A tener en cuenta',
    low: 'Menor',
  },

  brief: {
    metaTitre: 'El Brief',
    metaDescription: 'Lo esencial de la geopolítica en 3 minutos: despachos de la semana, análisis recientes, última verificación.',
    kicker: 'El Brief · {date}',
    titre: 'Tres minutos para la semana',
    faitsARetenir: { one: 'hecho a retener · con fuentes', other: 'hechos a retener · con fuentes' },
    aRetenir: 'Lo que hay que retener esta semana',
    semaineCalme: 'Semana tranquila: ningún hecho importante relacionado con nuestros análisis. El hilo completo está en',
    lActualite: 'la actualidad',
    pourComprendre: 'Para entender · {famille}:',
    sources: 'Fuentes',
    cestTout: 'Eso es todo por esta semana. ¿Quiere profundizar?',
    touteActu: 'Ver toda la actualidad →',
  },

  portes: {
    publie: 'Lo que hemos publicado',
    nbPublications: { one: '{n} publicación sobre {nom}', other: '{n} publicaciones sobre {nom}' },
    baroDefaut: 'Compromisos frente a los hechos, uno por uno',
    leBarometre: 'El barómetro',
    anglesReserves: { one: '{n} enfoque más, reservado a suscriptores', other: '{n} enfoques más, reservados a suscriptores' },
    voirAngles: 'Ver los enfoques',
    leDossierDe: 'El expediente {nom}',
    leDossier: 'El expediente',
    leVerdict: 'El veredicto →',
  },

  listes: {
    plutotVrais: { one: '{n} más bien verdadero', other: '{n} más bien verdaderos' },
    partiellementVrais: { one: '{n} parcialmente verdadero', other: '{n} parcialmente verdaderos' },
    plutotFaux: { one: '{n} más bien falso', other: '{n} más bien falsos' },
    verdictsPublies: 'Veredictos publicados: {legende}',
  },

  aria: {
    filAriane: 'Ruta de navegación',
  },

  acteur: {
    positions: 'Posiciones en los análisis',
    voirPositions: { one: 'Ver {n} posición más', other: 'Ver {n} posiciones más' },
    positionsPremium: 'Las posiciones en los análisis están reservadas a los suscriptores Premium',
    apparaitDans: { one: 'Aparece en {n} análisis', other: 'Aparece en {n} análisis' },
    analyseN: 'Análisis #{n}',
    voirAnalyses: { one: 'Ver {n} análisis más', other: 'Ver {n} análisis más' },
    pasDansCorpus: 'Este actor aún no aparece en los análisis del corpus.',
    aucuneRelation: 'Ninguna relación ni participación documentada para este actor.',
    orgInconnue: 'Organización desconocida',
    inconnu: 'Desconocido',
    nbRelations: { one: '{n} relación', other: '{n} relaciones' },
    nbOrganisations: { one: '{n} organización', other: '{n} organizaciones' },
    nouveautesReseau: 'Novedades en la red',
    detecteesRecemment: '· detectadas recientemente',
    aujourdhui: 'hoy',
    hier: 'ayer',
    ilYaJ: 'hace {n} d',
    participations: 'Participación en eventos',
    voirOrganisations: { one: 'Ver {n} organización más', other: 'Ver {n} organizaciones más' },
    nbEvents: { one: '{n} evento', other: '{n} eventos' },
    roles: {
      speaker: 'Ponente',
      attendee: 'Participante',
      organizer: 'Organizador',
      moderator: 'Moderador',
      observer: 'Observador',
    },
    relations: {
      inner_circle: 'Círculo cercano',
      political: 'Política',
      corporate: 'Negocios',
      media: 'Medios',
      international: 'Internacional',
      unexpected: 'Inesperada',
    },
    chargement: 'Cargando…',
    introuvable: 'Actor no encontrado',
    retour: '← Volver a los actores',
    acteur: 'Actor',
    explorerReseau: 'Explorar su red en el grafo →',
    enBref: 'En resumen',
    wikipedia: 'Wikipedia ↗',
    affiliations: 'Afiliaciones',
    frequente: 'Frecuenta estas organizaciones',
    organisationN: 'Organización #{n}',
    membres: {
      founder: 'Fundador',
      core_member: 'Miembro',
      alumni: 'Antiguo miembro',
      young_leader: 'Young Leader',
      invitee: 'Invitado',
      honorary: 'Honorario',
      emerging: 'Emergente',
    },
    onglets: {
      analyses: 'Análisis e investigaciones',
      reseau: 'Red',
      contexte: 'En nuestros análisis',
      actualites: 'Actualidad',
    },
    analyserEnEntier: '¿Hay que analizar a {nom} a fondo?',
    analyserSous: 'Proponga este análisis a votación: los temas más pedidos se examinan a fondo: coherencia de los compromisos, redes, fuentes.',
    enqueter: '¿Hay que investigar a {nom}?',
    enqueterSous: 'Proponga esta investigación a votación: la demanda decide lo que analizamos después.',
  },

  enq3: {
    essentielSous: 'Lo que la investigación establece a contracorriente de la idea recibida. Elija un hecho: a la derecha, los allegados que nombra.',
    constatMajeur: 'La constatación más significativa',
    apparaitDansN: { one: 'vuelve en {n} otro elemento de la investigación', other: 'vuelve en {n} otros elementos de la investigación' },
    nommeN: { one: 'nombra a {n} allegado', other: 'nombra a {n} allegados' },
    sertAussiN: { one: 'sustenta {n} elemento de la investigación', other: 'sustenta {n} elementos de la investigación' },
    depuis: 'desde {annee}',
    ouApparait: 'Dónde vuelve en la investigación',
    nulleParAilleurs: 'La investigación no lo nombra en ninguna otra parte.',
    prochesNommes: 'Los allegados que nombra',
    memeSource: 'La misma fuente sustenta también',
    ouSert: 'Lo que la investigación saca de ella',
    sourceGenerale: 'Ningún elemento concreto cita esta dirección: documenta la investigación en su conjunto.',
    groupes: {
      essentiel: 'Lo esencial', parcours: 'La trayectoria', formation: 'Formación', parcoursPrive: 'Trayectoria privada',
      affaires: 'Los procedimientos', enquetesEnCours: 'Investigaciones en curso', recoupement: 'La verificación cruzada, caso por caso',
      flux: 'Los flujos documentados', conflits: 'Conflictos de intereses documentados', patrimoine: 'Patrimonio', transactions: 'Transacciones destacadas',
      construction: 'La construcción, periodo por periodo', trainDeVie: 'Tren de vida y bienes',
      premierCercle: 'El círculo íntimo', politique: 'En política', milieuAffaires: 'En los negocios', presse: 'En la prensa', international: 'En el ámbito internacional',
      cerclesInfluence: 'Círculos de influencia', liensInattendus: 'Vínculos inesperados', nominations: 'Cómo nombra', protection: 'Protección institucional', opposants: 'Sus opositores',
      mecanismes: 'Los mecanismos', amplifie: 'Lo que se amplifica', disparait: 'Lo que desaparece', favorables: 'Medios descritos como favorables', critiques: 'Medios descritos como críticos',
      contradictions: 'Lo que se dijo, lo que se hizo', ordinaire: 'Lo que se aparta de lo ordinario', schemas: 'Los patrones que se repiten', hypotheses: 'Hipótesis en competencia',
      centrale: 'La pregunta central', questions: 'Las otras preguntas', rumeursEcartees: 'Rumores descartados por falta de verificación', manque: 'Lo que falta para zanjar', biais: 'Los posibles sesgos de esta investigación',
      sources: 'Las fuentes',
    },
    etiquettes: {
      decisions: 'Lo que señala la investigación', anomalies: 'Lo que desentona', refutation: 'Elementos de refutación',
      declare: 'Declarado', estime: 'Estimado', ecart: 'Diferencia', benefices: 'Lo que gana cada uno', roleReel: 'Papel oficial, papel real',
      observe: 'Observado', attendu: 'Esperado', intention: 'Si es una intención', coincidence: 'Si es una coincidencia', systeme: 'Si es el sistema',
      raison: 'Por qué se descarta', biais: 'Lo que orienta esta fuente',
    },
  },
  veille3: {
    sommaire: 'Índice de la vigilancia',
    surtitre: 'Vigilancia',
    titre: 'Qué leer',
    fil: 'Todo el hilo',
    groupeMoment: 'Por momento',
    groupeNature: 'Por naturaleza',
    avenir: 'Próximamente',
    semaine: 'Esta semana',
    mois: 'Este mes',
    ancien: 'Más antiguo',
    major_evolution: 'Evoluciones mayores',
    contradiction: 'Contradicciones',
    scenario_update: 'Perspectivas',
    new_relationship: 'Nuevas relaciones',
    sujets: 'Los temas seguidos',
    unite: 'despachos',
    uniteSujets: 'temas',
    critiquesSeules: 'Solo críticos',
    nonDatees: 'Sin fecha de evento',
    nonDateesAide: 'Contradicciones halladas por la vigilancia en hechos más antiguos: no son actualidad del día.',
    releveeLe: 'hallada el {date}',
    contexte: 'Contexto',
    quiBouge: 'Lo que más se mueve',
    quiBougeAide: 'Los temas con más despachos en treinta días.',
    nRecents: { one: '{n} despacho en 30 días', other: '{n} despachos en 30 días' },
    laSuite: 'La continuación de este tema',
    seule: 'Ningún otro despacho sobre este tema.',
    voirFiche: 'Ver la ficha →',
    toutLeSujet: 'Todo el tema en el centro →',
    sujetChoisi: 'El hilo: {sujet}',
    retirerSujet: 'Volver a todo el hilo',
    choisir: 'Elegir un despacho muestra su resumen, sus fuentes y la continuación de su tema.',
    rien: 'Nada aquí con estos filtros.',
    pivot: 'Cambiar de menú',
    parSujet: 'Por tema',
    nSujets: { one: '{n} tema', other: '{n} temas' },
  },
  org3: {
    tous: 'Todos',
    legendeToile: 'Cuanto más fuerte es el vínculo (fuerza de 1 a 10), más cerca está la organización y más grueso el trazo; punteado: fuerza no registrada',
    legendeMembres: 'Anillo interior: miembros actuales · exterior: antiguos miembros, invitados y miembros sin periodo fechado',
    essentielSous: 'Lo que hay que saber de la organización. A la derecha: la ficha en breve y las personas que más aparecen en ella.',
    enBref: 'En breve',
    fondee: 'Fundada',
    siege: 'Sede',
    statut: 'Estatuto',
    pays: { one: 'Activa en {n} país', other: 'Activa en {n} países' },
    quiRevient: 'Quienes más aparecen en la ficha',
    nElements: { one: '{n} elemento', other: '{n} elementos' },
    apparaitDansN: { one: 'aparece en {n} elemento más de la ficha', other: 'aparece en {n} elementos más de la ficha' },
    nommeN: { one: 'nombra a {n} miembro de la ficha', other: 'nombra a {n} miembros de la ficha' },
    sertAussiN: { one: 'respalda {n} elemento de la ficha', other: 'respalda {n} elementos de la ficha' },
    ouApparait: 'Dónde aparece en la ficha',
    nulleParAilleurs: 'La ficha no lo nombra en ningún otro lugar.',
    nommes: 'Los miembros que nombra',
    memeSource: 'La misma fuente respalda también',
    ouSert: 'Lo que la ficha extrae de ella',
    sourceGenerale: 'Ningún elemento concreto cita esta dirección: documenta la ficha en su conjunto.',
    roles: {
      fondateur: 'Fundador', membre: 'Miembro', invitesStrategiques: 'Invitado estratégico', opposantsCooptes: 'Opositor cooptado',
      leadersEmergents: 'Líder emergente', multiAffilie: 'Miembro compartido con otras organizaciones',
    },
    groupes: {
      identite: 'Lo que dice ser, lo que persigue', phases: 'Las fases', fondation: 'La fundación', fondateurs: 'Los fundadores', structure: 'La estructura',
      invitesStrategiques: 'Invitados estratégicos', opposantsCooptes: 'Opositores cooptados', leadersEmergents: 'Líderes emergentes cultivados',
      recommandations: 'Recomendaciones seguidas', crises: 'Crisis vistas venir', canaux: 'Los canales de influencia', evenements: 'Los encuentros',
      financements: 'Fuentes de financiación', circuit: 'El circuito del dinero', conflits: 'Conflictos de intereses', depenses: 'Adónde va el dinero', manquements: 'Faltas de transparencia',
      ecosysteme: 'El ecosistema', orgsLiees: 'Organizaciones vinculadas', multiAffilies: 'Miembros compartidos', position: 'Su posición en la red', coordination: 'Cómo se coordina la red',
      verdict: 'El veredicto', constats: 'Constataciones clave', anomalies: 'Anomalías', problematiques: 'Lo que plantea problemas', legitimes: 'Contribuciones legítimas',
      recommandationsFiche: 'Lo que recomienda la ficha', effets: 'Lo que produce',
      limites: 'Los límites de los datos', appui: 'La solidez de la ficha', pistes: 'Líneas de investigación', sources: 'Las fuentes',
    },
    etiquettes: {
      realisations: 'Logros', niveau: 'Nivel de influencia', motivations: 'Motivaciones analizadas', connexions: 'Conexiones', trajectoire: 'Trayectoria',
      nonDivulgues: 'Temas no divulgados', contributeurs: 'Principales contribuyentes', conditions: 'Condiciones', etapes: 'Las etapas', roi: 'Lo que reporta',
      preuves: 'Pruebas', biais: 'Lo que orienta esta fuente',
    },
  },
  bs3: {
    vue: 'Visión de conjunto',
    vueTitre: 'Las promesas de {nom}, frente a los hechos',
    vueChapo: 'Nota de coherencia: {note}/10 — {libelle}. Cada constatación abre su sección; cada promesa lleva un número, el mismo en toda la página.',
    groupeVerdict: 'El veredicto',
    retenir: 'Lo que hay que retener',
    attention: 'Puntos de atención',
    schema: 'El patrón recurrente',
    note: 'Por qué esta nota',
    groupePromesses: 'Las promesas',
    toutes: 'Todas',
    declarations: 'Declaraciones',
    groupeDepuis: 'Desde entonces',
    depuis: 'Lo que ha dicho desde entonces',
    nonTenusSur: { one: '{n} no cumplida de {total}', other: '{n} no cumplidas de {total}' },
    nTenus: { one: '{n} cumplida', other: '{n} cumplidas' },
    nPartiels: { one: '{n} cumplida en parte', other: '{n} cumplidas en parte' },
    nNonTenus: { one: '{n} no cumplida', other: '{n} no cumplidas' },
    nDeclarations: { one: '{n} declaración', other: '{n} declaraciones' },
    nNonEvaluables: { one: '{n} no evaluable', other: '{n} no evaluables' },
    domaines: 'Por ámbito',
    moinsTenu: 'La menos cumplida: {domaine}, {note}/10',
    mieuxTenu: 'La más cumplida: {domaine}, {note}/10',
    depuisReserve: 'Las tomas de posición registradas desde entonces, promesa por promesa',
    nPositions: { one: '{n} toma de posición registrada desde entonces', other: '{n} tomas de posición registradas desde entonces' },
    nPositionsCourt: { one: '{n} posición desde entonces', other: '{n} posiciones desde entonces' },
    depuisSous: { one: 'Vinculada a {n} promesa', other: 'Vinculadas a {n} promesas' },
    depuisChapo: 'Lo que la vigilancia ha registrado de sus palabras, vinculado a la promesa que toca. Línea continua: un vínculo; discontinua: un acercamiento.',
    depuisTitre: 'Lo que ha dicho desde entonces',
    depuisReserveLong: 'Las tomas de posición registradas desde entonces, vinculadas a cada promesa, están reservadas a los suscriptores.',
    enFrancais: 'Tomas de posición registradas en francés.',
    rapprochement: 'acercamiento',
    rapprochementAide: 'Un acercamiento: la posición toca el tema de esta promesa sin referirse a ella directamente.',
    lienAide: 'La posición trata directamente de esta promesa.',
    laPromesseTouchee: 'La promesa que toca',
    analyse: 'En el análisis «{titre}»',
    parDomaine: 'Las promesas, ámbito por ámbito',
    parDomaineAide: 'Cada pastilla es una promesa, con su nota de cumplimiento sobre 10 (discontinua: una declaración, calificada por su franqueza). Un clic la abre.',
    commentTitre: 'Cómo se hace este balance',
    selection: '{collectes} compromisos públicos recopilados, {retenus} retenidos para este balance.',
    ecartes: 'Descartados de la selección',
    lesPires: 'Las menos cumplidas',
    constatsAide: 'Elija una constatación: a la derecha, las promesas que evoca, cada una con su número.',
    promessesInvoquees: 'Las promesas que evoca',
    promessesInvoqueesSous: 'Un clic abre la promesa en detalle.',
    promessesNommeesSous: 'Reconocidas por los términos del pasaje. Un clic abre la promesa en detalle.',
    aucuneInvoquee: 'Este pasaje no remite a ninguna promesa en particular.',
    nPromesses: { one: '{n} promesa', other: '{n} promesas' },
    tropVague: 'demasiado vaga para medirse',
    nReserves: { one: '{n} reserva', other: '{n} reservas' },
    promesseN: 'Promesa {n}',
    ceQueDitLeVerdict: 'Lo que dice el veredicto',
    precedente: 'Anterior',
    suivante: 'Siguiente',
  },
  plus3: {
    vue: 'Visión de conjunto',
    vueChapo: 'Lo que el análisis documenta más allá de los hechos: de dónde viene el asunto, adónde puede ir, a quién afecta y en qué se apoya. Cada constatación abre su sección.',
    groupeTemps: 'El tiempo',
    groupeGens: 'Las personas',
    groupeMethode: 'El método',
    precedents: 'Precedentes',
    impact: 'A quién afecta',
    reseaux: 'Las redes',
    sources: 'Las fuentes',
    chronoConstat: { one: '{n} acontecimiento, de {debut} a {fin}', other: '{n} acontecimientos, de {debut} a {fin}' },
    chronoChapo: 'Por orden de fechas. Elija un acontecimiento: a la derecha, lo que cambió y lo que dicen sus fuentes.',
    peuConnus: { one: 'De ellos, {n} poco conocido.', other: 'De ellos, {n} poco conocidos.' },
    precedentsConstat: { one: '{n} precedente histórico', other: '{n} precedentes históricos' },
    precedentsChapo: 'Lo que ya ocurrió de parecido: lo que se asemeja, lo que difiere y lo que se puede sacar de ello.',
    sourcesDuPrecedent: 'Las fuentes que cita este precedente. Una marca del texto resalta la suya.',
    scenarioHaut: 'El más probable: {titre} — {p} %',
    scenariosConstat: { one: '{n} escenario estimado', other: '{n} escenarios estimados' },
    scenariosChapo: { one: '{n} escenario. Elija un escenario: a la derecha, lo que lo desencadenaría, lo que provocaría y a quién concierne.', other: '{n} escenarios, del más probable al menos probable. No todos se excluyen: sus probabilidades no tienen por qué sumar 100. Elija un escenario: a la derecha, lo que lo desencadenaría, lo que provocaría y a quién concierne.' },
    echeance: 'plazo {date}',
    declencheurs: 'Lo que lo desencadenaría',
    implications: 'Lo que provocaría',
    acteursConcernes: 'Los actores a los que concierne',
    probaBouge: 'Cómo ha variado su probabilidad',
    acteursConstat: { one: '{n} actor, {k} de ellos discretos', other: '{n} actores, {k} de ellos discretos' },
    plusGrandEcart: 'La mayor diferencia: {nom}, {n} puntos más de influencia que de visibilidad',
    nuageAria: 'Los actores situados según su visibilidad y su influencia',
    zoneDiscrete: 'Actúa más de lo que se ve',
    nuageAide: 'Por encima de la diagonal: más influencia que visibilidad. Se puede elegir un punto.',
    famille: { visible: 'Visibles', discret: 'Discretos', victime: 'Víctimas' },
    familleTitre: { visible: 'Los visibles, por influencia', discret: 'Los discretos, por diferencia', victime: 'Las víctimas' },
    tous: 'Todos',
    jaugesAide: 'En cada línea: la influencia (barra oscura) y luego la visibilidad (barra violeta).',
    lectures: 'Lo que muestra la distribución',
    lecturesChapo: 'Las lecturas del análisis sobre el conjunto de actores. Elija un actor: a la derecha, su posición.',
    lectureEcart: 'Influencia y visibilidad',
    lectureVictimes: 'Lo que sufren las víctimas',
    scenariosDeLActeur: 'Los escenarios en los que cuenta',
    voirFiche: 'Ver su ficha',
    profilsConstat: { one: '{n} perfil afectado', other: '{n} perfiles afectados' },
    plusTouche: 'El más afectado: {profil}, {n}/10',
    ecartConstat: 'Una diferencia de {n}/100 entre lo que dicen los medios y lo que se dice en línea',
    recitsQuiMontent: 'Los relatos que suben',
    parPlateforme: 'Por plataforma',
    sourcesConstat: { one: '{n} fuente', other: '{n} fuentes en {cats} familias' },
    sourcesChapo: 'De la más citada a la menos citada. Para cada una: su fiabilidad sobre 10, su sesgo y lo que aporta al análisis.',
    sourcesAide: 'Elija una fuente: a la derecha, qué es y dónde la cita el análisis.',
    plusCitee: 'La más citada: {media}, por {n} elementos del análisis',
    toutes: 'Todas',
    fiabilite: 'Fiabilidad sobre 10',
    citeeParN: { one: 'citada por {n} elemento', other: 'citada por {n} elementos' },
    citeeNullePart: 'no la cita ningún elemento detallado',
    citeeNullePartLong: 'Ningún hecho, relato, acontecimiento, precedente, escenario ni perfil la cita por su etiqueta. Puede alimentar la introducción o el planteamiento.',
    quiParle: 'Quién habla',
    passagesRetenus: 'Los pasajes que retuvo el análisis',
    ouCitee: 'Dónde la cita el análisis',
    lieu: {
      fait: { one: '{n} hecho establecido', other: '{n} hechos establecidos' },
      recit: { one: '{n} relato', other: '{n} relatos' },
      chronologie: { one: '{n} acontecimiento', other: '{n} acontecimientos' },
      precedent: { one: '{n} precedente', other: '{n} precedentes' },
      scenario: { one: '{n} escenario', other: '{n} escenarios' },
      impact: { one: '{n} perfil afectado', other: '{n} perfiles afectados' },
    },
    perspectivesManquantes: 'Los puntos de vista que faltan',
    biais: 'Los sesgos señalados',
    acces: 'Lo que no se pudo consultar',
    aSuivre: 'Por seguir',
    aSuivreChapo: 'Los plazos de los escenarios y los acontecimientos poco conocidos de la cronología.',
    echeances: 'Los próximos plazos',
    peuConnusTitre: 'Poco conocidos',
    rienASuivre: 'Ningún plazo próximo.',
    pourquoiPeuConnu: 'Por qué es poco conocido',
    portee: 'Lo que cambió',
    sansSource: 'Ninguna fuente citada.',
    avant: 'Antes',
    apres: 'Después',
  },
  faits3: {
    rubriques: 'Secciones de la pestaña',
    contexte: 'Contexto',
    vue: 'Visión de conjunto',
    groupeEtabli: 'Lo establecido',
    groupeDivise: 'Lo que divide',
    groupePlus: 'Ver también',
    faitsEtablis: 'Hechos establecidos',
    fractures: 'Las fracturas',
    debat: 'Lo que el debate no dice',
    recits: 'Los relatos',
    vueTitre: 'Lo que está establecido, lo que divide',
    vueChapo: 'Los hechos que establecen las fuentes, y lo que cada relato hace con ellos. Cada constatación abre la sección que la detalla.',
    nFaits: { one: '{n} hecho establecido', other: '{n} hechos establecidos' },
    niveau: { high: 'Seguro', medium: 'Probable', low: 'Frágil' },
    niveauTitre: { high: 'Establecidos con certeza', medium: 'Probables', low: 'Frágiles' },
    nNiveau: {
      high: { one: '{n} seguro', other: '{n} seguros' },
      medium: { one: '{n} probable', other: '{n} probables' },
      low: { one: '{n} frágil', other: '{n} frágiles' },
    },
    nContestes: { one: '{n} cuestionado por al menos una fuente', other: '{n} cuestionados por al menos una fuente' },
    socleTitre: 'El terreno común',
    socleConstat: { one: '{n} hecho cuyas fuentes citan todos los relatos', other: '{n} hechos cuyas fuentes citan todos los relatos' },
    socleAucun: 'Ningún hecho cuyas fuentes citen todos los relatos',
    socleChapo: 'Lecturas opuestas citan las mismas fuentes sobre estos hechos: el desacuerdo está en otra parte.',
    propresTitre: 'Lo que cada relato guarda para sí',
    propresChapo: 'Los hechos cuyas fuentes cita un solo relato.',
    seulRecit: 'Solo el relato {n} cita sus fuentes',
    matriceTitre: 'Qué relatos citan las fuentes de qué hechos',
    matriceAide: 'Un punto: el relato cita al menos una fuente del hecho; cuanto más grande, más fuentes. Citar una fuente no es aprobarla.',
    recitN: 'Relato {n}',
    nSources: { one: '{n} fuente', other: '{n} fuentes' },
    ceQueDisent: 'Lo que dicen sus fuentes',
    sansCitation: 'El análisis no retuvo ningún pasaje de esta fuente para este hecho.',
    elements: 'Los elementos retenidos',
    quiConteste: 'Quién lo cuestiona',
    nonConteste: 'Ninguna fuente lo cuestiona.',
    recitsQuiCitent: 'Los relatos que citan sus fuentes',
    aucunRecit: 'Ningún relato cita sus fuentes.',
    lireRecit: 'Leer el relato',
    reperesAide: 'Elija una marca numerada: a la derecha, la fuente que cita.',
    sourcesCitees: 'Fuentes citadas',
    faitsMemesSources: 'Hechos establecidos sobre las mismas fuentes',
    aucunFaitMemesSources: 'Ningún hecho establecido descansa en estas fuentes.',
    faitsDuRecit: 'Hechos establecidos cuyas fuentes cita',
    aucunFaitDuRecit: 'No cita las fuentes de ningún hecho establecido.',
    contredit: { one: '{n} elemento lo contradice', other: '{n} elementos lo contradicen' },
    recitsTitre: { one: '{n} relato sobre el mismo asunto', other: '{n} relatos sobre el mismo asunto' },
    recitsChapo: 'Elija un relato: a la derecha, los hechos establecidos cuyas fuentes cita.',
    faitsCites: { one: '{n} hecho establecido citado', other: '{n} hechos establecidos citados' },
  },
  acteur3: {
    rubriques: 'Secciones de la ficha',
    contexte: 'Contexto',
    chargement: 'Cargando…',
    groupePublie: 'Lo establecido',
    groupeReseau: 'Su red',
    groupeActu: 'En la actualidad',
    publications: 'Nuestras publicaciones',
    reseau: 'Relaciones documentadas',
    organisations: 'Pertenencias',
    positions: 'Posiciones registradas',
    veille: 'Vigilancia',
    publiTitre: { one: '{n} publicación', other: '{n} publicaciones' },
    publiChapo: 'Elija una publicación para ver, a la derecha, lo que la vincula con el resto de la ficha.',
    consacrees: 'Dedicadas a {nom}',
    analysesRole: 'Los análisis en los que {nom} desempeña un papel',
    verifications: 'Las afirmaciones verificadas',
    analyse: 'Análisis',
    verification: 'Verificación de una afirmación',
    comptage: { one: '{n} compromiso notable: {detail}', other: '{n} compromisos notables: {detail}' },
    nTenus: { one: '{n} cumplido', other: '{n} cumplidos' },
    nTrahis: { one: '{n} traicionado', other: '{n} traicionados' },
    nIntermediaires: { one: '{n} intermedio', other: '{n} intermedios' },
    role: 'Papel: {role}',
    leConstat: 'La constatación principal',
    laQuestion: 'La pregunta que sigue abierta',
    lEssentiel: 'Lo esencial del análisis',
    leVerdict: 'El veredicto',
    reseauBarometre: 'En su red, también evaluados por un barómetro',
    aussiDansAnalyse: 'También en este análisis, y en su red',
    aucunCroisement: 'Nadie de su red documentada desempeña un papel en él.',
    ouvrirBarometre: 'Abrir el barómetro',
    lireInvestigation: 'Leer la investigación',
    ouvrirAnalyse: 'Abrir el análisis',
    lireVerification: 'Leer la verificación',
    ouvrirFiche: 'Abrir la ficha de {nom}',
    ouvrirOrg: 'Abrir la ficha de la organización',
    citeesTitre: 'Citadas en sus relaciones, no establecidas',
    citeesAide: 'Organizaciones que su red menciona, sin que ninguna lista de miembros o participantes lo inscriba. Una mención no es una pertenencia: cada una se da con la relación que la sostiene y su fuente.',
    citeesNonEtablie: { one: 'no establecida · citada en {n} relación', other: 'no establecida · citada en {n} relaciones' },
    citeesFait: 'hecho reportado',
    citeesLecture: 'nuestra lectura',
    citeesSource: 'fuente ↗',
    reseauTitre: { one: '{n} persona', other: '{n} personas' },
    reseauChapo: 'Elija una persona para ver, a la derecha, en qué se basa la relación y dónde se cruzan las dos fichas.',
    depuis: 'desde {annee}',
    ceQuiFonde: 'En qué se basa la relación',
    lecture: 'interpretación, no un hecho establecido',
    dossierRetient: 'El expediente de {nom} recoge: «{intitule}»',
    etabliPar: 'Establecido por {qui}',
    sansSource: 'ninguna fuente citada para este vínculo',
    seCroisent: 'Dónde se cruzan las dos fichas',
    membresTousDeux: 'Organización · ambos son miembros',
    analyseCommune: 'Análisis · un papel para cada uno',
    aSonBarometre: 'También tiene su barómetro',
    rienEnCommun: 'Ningún otro cruce en el sitio aparte de esta relación.',
    orgsTitre: { one: '{n} organización', other: '{n} organizaciones' },
    orgsChapo: 'Elija una organización para ver, a la derecha, sus otros miembros que también figuran en su red, y los encuentros en los que consta su presencia.',
    membresRepertories: { one: '{n} otro miembro registrado', other: '{n} otros miembros registrados' },
    dontReseau: { one: 'de ellos {n} en su red', other: 'de ellos {n} en su red' },
    poste: 'Cargo registrado',
    membresDuReseau: 'También miembros, y en su red',
    aucunMembreReseau: 'Ningún otro miembro registrado figura en sus relaciones documentadas.',
    rencontres: 'Encuentros en los que consta su presencia',
    orgNonPubliee: 'La ficha de esta organización aún no está publicada.',
    positionsTitre: { one: '{n} posición registrada', other: '{n} posiciones registradas' },
    positionsChapo: 'Lo que nuestros análisis y nuestra vigilancia han registrado, fechado y con fuente. Elija una posición para ver su fuente.',
    laPosition: 'La posición',
    enFrancais: 'Texto en francés: las posiciones registradas aún no están traducidas.',
    source: 'Fuente',
    sansSourcePosition: 'Ninguna dirección de fuente para esta posición.',
    analyseLiee: 'Registrada en el análisis',
    veilleTitre: 'Lo que ha registrado la vigilancia',
    vue: 'Visión de conjunto',
    vueTitre: 'Lo que establece la ficha',
    vueChapo: 'Constataciones extraídas de nuestras publicaciones y registros. Cada una abre la sección que la detalla.',
    promesses: 'Promesas',
    investigation: 'Investigación',
    analysesVerifs: 'Análisis y verificaciones',
    fil: 'Hilo de la actualidad',
    barometreDate: 'Barómetro de promesas · {date}',
    investigationDate: 'Investigación · {date}',
    reseauConstat: { one: '{n} persona documentada', other: '{n} personas documentadas' },
    dontCercles: { one: ', {n} de ellas en los círculos de la investigación', other: ', {n} de ellas en los círculos de la investigación' },
    orgConstat: '{org}: {k} de los {m} otros miembros están en su red',
    filConstat: 'La última el {date}: {titre}',
    anaRole: { one: 'Un papel en {n} análisis', other: 'Un papel en {n} análisis' },
    nVerifs: { one: '{n} afirmación verificada', other: '{n} afirmaciones verificadas' },
    nRattachees: { one: '{n} posición del hilo vinculada', other: '{n} posiciones del hilo vinculadas' },
    partoutTitre: 'Las personas que aparecen en todas partes',
    partoutChapo: 'Cruce de las relaciones documentadas, los círculos de la investigación, las organizaciones, los análisis y los barómetros.',
    partoutVide: 'Nadie de su red cruza la ficha en otro lugar que en la propia relación.',
    nCroisements: { one: '{n} cruce', other: '{n} cruces' },
    badgeRelation: 'Relación',
    badgeInvestigation: 'Investigación',
    badgeAnalyse: 'Análisis',
    badgeBarometre: 'Su barómetro',
    laParole: 'Sus palabras',
    conclusion: 'Lo que concluye el barómetro',
    depuisBarometre: 'Lo que el hilo de la actualidad vincula',
    aucunePositionPromesse: 'Ninguna posición del hilo está vinculada a este compromiso.',
    rapprochement: 'Posible vínculo',
    rapprochementAide: 'Vínculo propuesto por un proceso automático con confianza media: léase como una pista.',
    chiffrable: 'cuantificable',
    qualitatif: 'cualitativo',
    autresAngles: 'Otros ángulos del barómetro',
    lesCercles: { one: 'Los círculos establecidos por la investigación · {n} persona o entidad', other: 'Los círculos establecidos por la investigación · {n} personas y entidades' },
    cerclesPremium: { one: 'La persona o entidad de sus círculos está reservada a los suscriptores.', other: 'Las {n} personas y entidades de sus círculos están reservadas a los suscriptores.' },
    dansInvestigation: 'En la investigación · {cercle}',
    relationDocumentee: 'Relación documentada',
    investigationSur: 'Investigación sobre {nom}',
    cercleNomme: 'Círculo «{cercle}»',
    sansFiche: 'Todavía no tiene ficha en el sitio.',
    tous: 'Todos',
    toutes: 'Todas',
    legendeAnneaux: 'Anillo interior: círculo cercano · medio: político · exterior: negocios, medios, internacional, inesperados',
    reseauKicker: 'Red · relaciones documentadas y círculos de la investigación',
    reseauTitreE2: { one: '{n} persona o entidad', other: '{n} personas y entidades' },
    orgsTitreE2: 'Dónde se reúne su red',
    orgsChapoE2: 'Elegir una organización resalta, en el grafo, a los miembros que figuran en su red.',
    membreDepuis: 'Miembro · {periode}',
    enMemeTemps: 'Miembros al mismo tiempo',
    enMemeTempsAide: 'Miembros cuyo periodo de pertenencia, fechado, coincide con el suyo. Formar parte de la misma organización no es una relación documentada.',
    legendeEnMemeTemps: 'punteado: miembros al mismo tiempo, sin relación documentada',
    depuisAn: 'desde {an}',
    enAn: 'en {an}',
    aussiReseau: 'también en su red',
    duReseau: '{n} de la red',
    filTitreE2: 'De {debut} a {fin}',
    nature: {
      contradiction: 'Contradicción',
      media: 'Aparición',
      role_change: 'Nombramiento',
    },
    nNatures: {
      contradiction: { one: '{n} contradicción', other: '{n} contradicciones' },
      media: { one: '{n} aparición mediática', other: '{n} apariciones mediáticas' },
      role_change: { one: '{n} nombramiento', other: '{n} nombramientos' },
    },
    rattacheAnalyse: 'Análisis al que pertenece la posición',
    rattachePromesse: 'Compromiso del barómetro que toca',
    positionsRattachees: 'Posiciones del hilo vinculadas a este análisis',
    analyseDeLaVerif: 'Análisis al que pertenece',
    analysesFil: 'Los análisis a los que lleva su hilo de actualidad',
    entree: 'Quién le hizo entrar',
    trouveDans: 'Encontrado en: {ou}',
    ouRelation: 'una relación documentada',
    ouInvestigation: 'los círculos de la investigación',
  },

  partages: {
    voirMoins: 'Ver menos',
    premiumReserve: 'Contenido reservado a los suscriptores Premium',
    premiumSansAcces: 'Su cuenta actual no da acceso a este contenido. Se necesita una suscripción Premium.',
    premiumConnexion: 'Este contenido está reservado a los suscriptores Premium. Inicie sesión si ya está suscrito.',
    seConnecter: 'Iniciar sesión',
    devenirPremium: 'Hacerse Premium →',
    retirerPortfolio: 'Quitar del portafolio',
    sauverPortfolio: 'Guardar en mi portafolio',
    enregistre: 'Guardado',
    sauvegarder: 'Guardar',
    reseauApercu: 'Red: vista previa',
    apercuDe: 'Vista previa de la red de {nom}',
    reseauDocumente: 'Red documentada',
    ouvrirGraphe: 'Abrir en El Grafo →',
    historique: 'Historial de la ficha',
    historiqueTexte: 'Esta ficha se actualiza de forma continua mediante nuestra vigilancia. Cada modificación queda registrada aquí, con sus fuentes.',
    voirEntrees: { one: 'Ver {n} entrada más', other: 'Ver {n} entradas más' },
    signalRecent: 'Señal reciente',
    exploite: 'aprovechado',
    confirme: 'confirmado',
    nouvellesRecentes: 'Noticias recientes ({n})',
    voirNouvelles: { one: 'Ver {n} noticia más', other: 'Ver {n} noticias más' },
    contradictions: 'Contradicciones detectadas ({n})',
    voirContradictions: { one: 'Ver {n} contradicción más', other: 'Ver {n} contradicciones más' },
  },

  proposer: {
    rayonx: {
      kicker: '¿Una afirmación que verificar?',
      sub: 'Envíela: la comunidad vota y nosotros la examinamos a fondo.',
      formTitle: 'Enviar una afirmación al RayonX',
      titlePlaceholder: 'La afirmación que verificar',
      descPlaceholder: 'Contexto / fuente (opcional)',
    },
    geo: {
      kicker: '¿Un tema que descifrar?',
      sub: 'Propóngalo: la comunidad vota y lo analizamos desde varios ángulos.',
      formTitle: 'Proponer un análisis',
      titlePlaceholder: 'El tema que analizar',
      descPlaceholder: '¿Por qué es pertinente este tema? (opcional)',
    },
    actor: {
      kicker: '¿Un actor que examinar a fondo?',
      sub: 'Propóngalo: la comunidad vota y estudiamos su coherencia y sus redes.',
      formTitle: 'Proponer un actor',
      titlePlaceholder: 'Nombre del actor',
      descPlaceholder: '¿Por qué este actor? (opcional)',
    },
    org: {
      kicker: '¿Una organización que cartografiar?',
      sub: 'Propóngala: la comunidad vota y cartografiamos sus redes de influencia.',
      formTitle: 'Proponer una organización',
      titlePlaceholder: 'Nombre de la organización',
      descPlaceholder: '¿Por qué esta organización? (opcional)',
    },
    echecEnvoi: 'No se pudo enviar la propuesta.',
    erreurReseau: 'Error de red, inténtelo de nuevo.',
    erreurN: 'Error {n}',
    envoyee: 'Propuesta enviada: se suma al Ágora, sometida a votación.',
    lancee: 'Análisis iniciado.',
    voirResultat: 'Ver el resultado →',
    voirAgora: 'Ver el Ágora →',
    autre: 'Proponer otro',
    proposer: 'Proponer →',
    connectez: 'Inicie sesión para proponer →',
    region: 'Región',
    domaine: 'Ámbito',
    annuler: 'Cancelar',
    envoi: 'Enviando…',
    soumettre: 'Enviar la propuesta',
    lancement: 'Iniciando…',
    executer: 'Ejecutar ahora',
  },

  orientation: {
    releves: {
      media: 'Aparición mediática',
      contradiction: 'Desfase constatado',
      role_change: 'Cambio de función',
      autre: 'Registro',
    },
    appartenances: {
      core_member: 'miembro',
      alumni: 'antiguo miembro',
      invitee: 'invitado',
      observer: 'observador',
      board_member: 'miembro del consejo',
    },
    liens: {
      inner_circle: 'círculo cercano',
      political: 'vínculo político',
      corporate: 'vínculo económico',
      media: 'vínculo mediático',
      family: 'vínculo familiar',
      financial: 'vínculo financiero',
      international: 'vínculo internacional',
      institutional: 'vínculo institucional',
      autre: 'vínculo',
    },
    laFiche: 'la ficha de {nom}',
    uneFicheOrg: 'una ficha de organización',
    lienAvec: '{type} con {sujet}',
    dossierRetient: ', que el expediente describe como «{libelle}»',
    analyseReseau: 'nuestro análisis de la red de {nom}',
    lienNonQualifie: 'vínculo sin calificar',
    depuis: ' (desde {date})',
    investigationSur: 'la investigación sobre {sujet}',
    unAutreActeur: 'otro actor',
    cercle: ', círculo «{cercle}»',
    evenement: 'evento',
    notreAnalyse: 'nuestro análisis «{titre}»',
    uneDeNosAnalyses: 'uno de nuestros análisis',
    analyseOuNom: 'nuestro análisis, donde aparece el nombre',
    revientDans: ': el nombre aparece en {n} de sus subinvestigaciones',
    anatomieOuNom: 'nuestra anatomía, donde el nombre figura en el registro',
    limiteRienEcrit: 'Nada de lo que aparece aquí se escribió sobre esta persona: cada línea se produjo analizando a otra persona o cosa.',
    limitePointDeVue: { one: 'El punto de vista es el del expediente {sujets}: ahí se registraron estos vínculos, y describen lo que ese expediente retiene.', other: 'El punto de vista es el de los expedientes {sujets}: ahí se registraron estos vínculos, y describen lo que esos expedientes retienen.' },
    limiteSansAdresse: '{n} elemento(s) de {total} no tienen ningún enlace verificable: se señalan como tales.',
    limiteAbsence: 'La ausencia de un hecho aquí no significa que no exista: significa que no lo hemos establecido.',
    cadrage: 'No tenemos ningún análisis dedicado a {nom}. Esta página reúne lo que nuestros otros trabajos han encontrado al respecto, cada vez con el expediente que lo establece y el enlace para verificarlo. No es un retrato, y la suma de estas líneas no constituye una conclusión.',
    fiche: {
      etabliPar: 'establecido por',
      lecture: '· una lectura, no establecida como hecho',
      aucuneAdresse: 'ningún enlace verificable',
      reperes: 'Referencias: no es un análisis de {nom}',
      fonction: 'Función registrada en nuestros datos:',
      releves: 'Registrado en nuestros análisis',
      relevesSous: 'Consignados y fechados a lo largo de nuestros trabajos, cada uno con su naturaleza.',
      appartenances: 'Pertenencias',
      appartenancesSous: 'Tomadas de las fichas de las organizaciones correspondientes.',
      liens: 'Vínculos registrados',
      liensSous: 'Descritos desde el punto de vista del expediente que los estableció, nunca desde el de esta persona.',
      cercles: 'Círculos de investigación',
      cerclesSous: 'Posición en el entorno de una persona que hemos investigado.',
      evenements: 'Eventos',
      evenementsSous: 'Presencias acreditadas en las fichas de organización.',
      mentions: 'Mencionado en nuestros trabajos',
      mentionsSous: 'El nombre aparece allí: para leer como contexto, no como conclusión.',
      assemble: 'Elaborado el {date} a partir de {natures} tipo(s) de material, de ellos {sourcees} elemento(s) con un enlace verificable.',
      rienPublie: 'No hemos publicado nada sobre esta persona',
      rienPublieTexte: '{nom} figura en nuestros datos porque uno de nuestros trabajos citó ese nombre. No hemos producido ningún análisis, ningún vínculo documentado ni ninguna fuente al respecto.',
      absence: 'Esta ausencia no dice nada de la persona: dice lo que no hemos hecho.',
    },
  },

  acteurs: {
    tous: 'Todos',
    kicker: 'Personalidades',
    kickerAnalysees: 'Personalidades · {n} analizadas',
    titre: 'Los rostros del poder',
    barometresPublies: { one: 'barómetro publicado', other: 'barómetros publicados' },
    notesGlobales: 'Las {n} notas globales de los barómetros publicados',
    recherche: 'Nombre, país, función…',
    type: 'Tipo',
    analyse: 'Análisis',
    toutes: 'Todas',
    barometre: 'Barómetro',
    investigation: 'Investigación',
    prochesDAbord: 'Primero tu región',
    plusContradictoires: 'Más contradictorios primero',
    plusCoherents: 'Más coherentes primero',
    nomAZ: 'Nombre, de la A a la Z',
    nbPersonnalites: { one: '{n} personalidad', other: '{n} personalidades' },
    aucunCorrespond: 'Ningún actor coincide',
    filtresRestrictifs: 'Puede que sus filtros sean demasiado restrictivos. Amplíe la búsqueda o restablézcalos.',
    reinitialiser: 'Restablecer los filtros',
    rienPourLinstant: 'Nada que mostrar por ahora',
    bientot: 'Los primeros perfiles llegarán pronto.',
    noteSur10: 'nota del barómetro sobre 10',
    metaTitre: 'Actores',
    metaDescription: 'Políticos, diplomáticos, lobistas: perfiles completos con puntuación de coherencia y red de influencia.',
    metaIntrouvable: 'Actor no encontrado',
    metaPersonnalite: 'Personalidad',
    metaProfil: '{type}: perfil, puntuación de coherencia y red de influencia analizados por Lumière Noire.',
  },

  filtres: {
    effacerRecherche: 'Borrar la búsqueda',
    tri: 'Orden',
    filtresEtTri: 'Filtros y orden',
    retirer: 'quitar',
    toutEffacer: 'Borrar todo',
  },

  divers: {
    reserveAbonnes: 'Reservado a los suscriptores.',
    seConnecter: 'Iniciar sesión',
    sAbonner: 'Suscribirse →',
    voirWikimedia: 'Ver el archivo y su licencia en Wikimedia',
    nonLisible: 'Organización citada en nuestros análisis: su ficha aún no se ha analizado.',
    sommaire: 'Índice',
    chargement: 'Cargando…',
    derniereMaj: 'Última actualización: {date}.',
    aCompleter: 'POR COMPLETAR',
  },

  rayonx: {
    domaines: {
      politique: 'Política',
      'économie': 'Economía',
      'santé': 'Salud',
      justice: 'Justicia',
      environnement: 'Medio ambiente',
      science: 'Ciencia',
      'société': 'Sociedad',
      international: 'Internacional',
      autre: 'Otro',
    },
    tri: {
      date_desc: 'Más recientes',
      date_asc: 'Más antiguos',
      score_desc: 'Mejor puntuados',
      score_asc: 'Peor puntuados',
    },
    statuts: {
      processing: 'En verificación',
      failed: 'Verificación fallida',
      draft: 'Privado',
      pending_review: 'En revisión',
      published: 'Publicado',
      rejected: 'Rechazado',
    },
    actions: {
      demander: {
        bouton: 'Solicitar la publicación',
        explication: 'Su RayonX pasa a revisión. Seguirá siendo privado hasta que el equipo decida: si se publica, todos podrán verlo y podrá aparecer en la portada; si se rechaza, sabrá por qué.',
        confirmer: 'Enviar a revisión',
      },
      annuler: {
        bouton: 'Cancelar la solicitud',
        explication: 'Se retira la solicitud de revisión. Su RayonX sigue siendo privado.',
        confirmer: 'Cancelar la solicitud',
      },
      retirer: {
        bouton: 'Volver a privado',
        explication: 'Su RayonX deja el sitio público. Para volver a publicarlo, tendrá que pasar de nuevo por la revisión.',
        confirmer: 'Volver a privado',
      },
    },
    actionEchouee: 'La acción no se completó.',
    erreurReseau: 'Error de red.',
    visibleTous: 'Visible para todos',
    visibleVous: 'Visible solo para usted',
    motifRefus: 'Motivo del rechazo:',
    neRienFaire: 'No hacer nada',
    mesRayonx: 'Mis RayonX',
    rayonxPublics: 'RayonX públicos',
    rayonx: 'RayonX',
    rechercheChamp: 'Una afirmación, una persona…',
    domaine: 'Ámbito',
    tous: 'Todos',
    compte: '{n} RayonX',
    pasEncore: 'Aún no ha lanzado ninguna verificación.',
    aucunFiltre: 'Ninguna verificación para este filtro.',
    utilisezAgora: 'Use el botón «Ejecutar ahora» en el Ágora para verificar una afirmación.',
    aucunPublic: 'Aún no hay verificaciones públicas.',
    onglets: {
      verdict: 'Veredicto',
      preuves: 'Pruebas',
      limites: 'Límites',
      methode: 'Método',
    },
    methodePerimetre: 'Método y alcance',
    formeAffirmative: 'Forma afirmativa verificada',
    reformulee: 'Afirmación reformulada (neutra)',
    notesMethodo: 'Notas metodológicas',
    perimetreAnalyse: 'Alcance analizado',
    periode: 'Periodo',
    perimetreGeo: 'Alcance geográfico',
    termesCles: 'Términos clave',
    recherches: 'Búsquedas realizadas ({n})',
    recherchesPlus: { one: '+ {n} búsqueda más →', other: '+ {n} búsquedas más →' },
    verification: 'Verificación',
    nbPreuves: { one: '{libelle} · {n} prueba', other: '{libelle} · {n} pruebas' },
    verdictComplet: 'El veredicto completo ↓',
    preuvesUneParUne: { one: 'La prueba, en detalle ↓', other: 'Las {n} pruebas, una por una ↓' },
    lienCopie: '✓ Enlace copiado',
    partager: 'Compartir',
    pointsCles: 'Puntos clave',
    preuvesCollectees: 'Pruebas recopiladas',
    aucunePreuve: 'Ninguna prueba indexada',
    limitesEntites: 'Límites y entidades',
  },

  preuves: {
    polarite: {
      confirms: 'Confirma',
      refutes: 'Refuta',
      nuance: 'Matiza',
    },
    poids: {
      eleve: 'alto',
      modere: 'moderado',
      faible: 'bajo',
    },
    types: {
      official: 'Oficial',
      media: 'Prensa',
      academic: 'Académico',
      factchecker: 'Verificador',
      legal: 'Jurídico',
      other: 'Otro',
    },
    filtres: {
      all: 'Todas',
      confirms: 'Confirman',
      refutes: 'Refutan',
      nuance: 'Matizan',
    },
    preuveN: 'Prueba {n}',
    preuveNMin: 'prueba {n}',
    poidsLibelle: 'Peso {poids}',
    aucuneCategorie: 'Ninguna prueba en esta categoría',
    allerA: 'Ir a la prueba {n}',
    voirPreuveN: 'Ver la prueba {n}',
    voirDansPreuves: 'Ver en las pruebas →',
    uneCase: 'Una casilla por prueba. Haga clic en un color para quedarse solo con esas pruebas.',
  },

  verdictRx: {
    confiance: {
      high: 'Confianza alta',
      medium: 'Confianza media',
      low: 'Confianza baja',
    },
    questionPosee: 'Pregunta planteada',
    affirmationVerifiee: 'Afirmación verificada',
    contexte: 'Contexto: {texte}',
    verifieLe: '· Verificado el {date}',
    raisonnement: 'Razonamiento detallado',
    parSousAffirmation: 'Veredicto por subafirmación',
    pourraitChanger: 'El veredicto podría cambiar si…',
    nuances: 'Matices a tener en cuenta',
    entites: 'Entidades implicadas',
    acteurs: 'Actores',
    organisations: 'Organizaciones',
    aucuneLimite: 'Ningún límite ni entidad identificados',
    roles: {
      subject: 'Sujeto',
      witness: 'Testigo',
      source: 'Fuente',
    },
    exact: 'Lo que es exacto',
    inexact: 'Lo que es inexacto o falta',
    preuvesUneParUne: { one: 'La prueba, en detalle →', other: 'Las {n} pruebas, una por una →' },
  },
  rx3: {
    sommaire: 'Índice del RayonX',
    entete: 'El veredicto y sus pruebas',
    verdict: 'El veredicto',
    sous: 'Las subafirmaciones',
    preuves: 'Las pruebas',
    methode: 'En qué se basa',
    sousSous: 'La afirmación dividida en partes verificables, cada una con su veredicto.',
    preuvesSous: { one: '{n} prueba, ordenada por sentido. Elija una: a la derecha, su fuente y lo que respalda.', other: '{n} pruebas, ordenadas por sentido. Elija una: a la derecha, su fuente y lo que respalda.' },
    methodeSous: 'Cómo se entendió la afirmación, a quién recurre la verificación, y dónde se buscó.',
    reserves: 'Las reservas',
    toutes: 'Todas las pruebas',
    appuie: 'Lo que respalda en el veredicto',
    citeeParSous: 'Citada por la subafirmación',
    ouvrirSource: 'Abrir la fuente',
  },

  rayonxListe: {
    kicker: 'RayonX · verificación, con pruebas',
    titre: '¿Verdadero, falso o más complicado?',
    legende: { one: 'afirmación pasada por los rayos X', other: 'afirmaciones pasadas por los rayos X' },
    metaDefaut: 'Análisis y verificación de fuentes por Lumière Noire.',
  },

  analyse: {
    fermerMaj: 'Cerrar esta actualización',
    detecteAuto: '{date}: detectado automáticamente',
    majMajeures: { one: 'Actualización importante', other: 'Actualizaciones importantes' },
    reduire: 'Reducir',
    voirLes: 'Ver las {n}',
    autresMaj: { one: '+ {n} actualización más', other: '+ {n} actualizaciones más' },
    chargement: 'Cargando…',
    impossible: 'No se pudo cargar este análisis.',
    sommaire: {
      chronologie: 'Acontecimientos de la cronología',
      historique: 'Precedentes históricos',
      scenarios: 'Perspectivas',
      impact: 'Perfiles de impacto ciudadano',
      resonance: 'Sentimientos dominantes en línea',
      sources: 'Fuentes documentadas',
    },
    analyses: 'Análisis',
    analyse: 'Análisis',
    consensusLectures: 'de consenso · {n} lecturas en competencia',
    version: 'Versión {v} · {date}',
    versionLien: 'Versión {v} →',
    pied: 'Lumière Noire · Análisis geopolítico multiperspectiva · {date}',
    onglets: {
      passe: 'Los hechos',
      lectures: 'Perspectivas',
      plus: 'Ir más lejos',
    },
    sectionsAria: 'Secciones del análisis',
    essentiel: {
      aria: 'Lo esencial del análisis',
      titre: 'Lo esencial',
      uneMinute: '1 min de lectura',
      etabli: 'Lo que está establecido',
      divise: 'Lo que divide',
      probable: 'Perspectiva más probable',
      suivi: '{initiale} % en el análisis · revisado el {date}',
      suiviJamais: '{initiale} % en el análisis',
      lireComplete: 'Leer el análisis completo ↓',
      confiance: {
        high: 'Confianza alta',
        medium: 'Confianza media',
        low: 'Confianza baja',
      },
    },
    fraicheur: {
      nonVerifie: 'No verificado',
      aJour: 'Actualizado',
      recommandee: 'Actualización recomendada',
      aVerifier: 'Datos por verificar',
      couverture: 'Cobertura: {date}',
      verifieLe: 'Verificado el {date}',
    },
    rendezVous: {
      aria: 'Las próximas citas de los análisis',
      titre: 'Las próximas citas',
      sous: 'el escenario fechado más cercano de cada tema',
      probabilite: 'Probabilidad estimada por el análisis',
    },
    liste: {
      kicker: 'Análisis · escenarios fechados',
      titre: 'Lecturas cruzadas',
      sujetsSuivis: { one: 'tema seguido', other: 'temas seguidos' },
      recherche: 'Buscar un análisis…',
      region: 'Región',
      domaine: 'Ámbito',
      statut: 'Estado',
      toutes: 'Todas',
      tous: 'Todos',
      publies: 'Publicados',
      brouillons: 'Borradores',
      plusRecentes: 'Más recientes',
      plusConsensuelles: 'Más consensuados',
      plusDisputees: 'Más disputados',
      aucune: 'Ningún análisis coincide',
      bientot: 'Los primeros análisis geopolíticos llegarán pronto.',
      deConsensus: 'de consenso',
      metaDescription: 'Análisis geopolíticos en profundidad: conflictos, trayectorias de poder, crisis. Descifrar hechos, no opiniones.',
      introuvable: 'Análisis no encontrado',
    },
  },

  plusLoin: {
    chronologie: 'Cronología',
    chronologieSub: '{n} acontecimientos · {caches} poco conocidos',
    historique: 'Profundidad histórica',
    historiqueSub: '{n} precedentes · Comparaciones «Antes / Ahora»',
    impact: 'Impacto ciudadano',
    impactSub: '{n} perfiles concretos',
    resonance: 'Lo que dicen las redes',
    resonanceSub: '{n} sentimientos dominantes',
    resonanceEcart: ' · brecha con los medios {ecart}/100',
    acteurs: 'Actores',
    acteursSub: 'Visibles · Ocultos · Víctimas · Beneficiarios',
    scenarios: '¿Y ahora?',
    scenariosSub: '{n} escenarios posibles · probabilidades · detonantes',
    sources: 'Fuentes completas',
    sourcesSub: '{n} fuentes · {cats} categorías · puntuaciones /10',
    evolution: 'Evolución',
    retour: '← Ir más lejos',
    titre: 'Ir más lejos',
    premiumEvolution: 'El análisis de la evolución está reservado a los suscriptores Premium',
    premiumActeurs: 'El análisis de los actores está reservado a los suscriptores Premium',
    premiumScenarios: 'Los escenarios están reservados a los suscriptores Premium',
    premiumImpact: 'El impacto ciudadano está reservado a los suscriptores Premium',
  },

  lectures: {
    rechercheRien: 'Lo que se buscó detrás de este relato: ninguna red documentada',
    rechercheN: { one: 'Lo que se buscó detrás de este relato: {n} red documentada', other: 'Lo que se buscó detrás de este relato: {n} redes documentadas' },
    biaisFaible: 'Sesgo bajo',
    biaisEleve: 'Sesgo alto',
    biaisMoyen: 'Sesgo medio',
    nbSources: '{n} fuentes',
    ceQueDit: 'Lo que dice esta lectura',
    detail: 'El detalle, argumento por argumento',
    argumentN: 'Argumento {n}',
    preuvesAppui: '{n} pruebas a favor',
    contradictoires: '{n} elementos contradictorios',
    anglesMorts: '{n} puntos ciegos',
    contexte: {
      recits: 'Los relatos',
      these: 'La tesis',
      aide: 'Elija un argumento: a la derecha, lo que lo sostiene.',
      titre: 'Contexto',
      source: 'Fuente {n}',
      retrouve: 'Encontrado en la página',
      pourPhrase: 'para la frase «{debut}»',
      retenu: 'Pasaje retenido por el análisis',
      pasRetrouve: 'La máquina no encontró esta frase en la página.',
      illisible: 'La máquina no pudo leer la página.',
      chiffresOk: 'Cifras encontradas: {liste}',
      chiffresManquants: 'Ausentes de este pasaje: {liste}',
      enLangue: 'en {langue}',
      donnees: 'Los datos del argumento',
      cliquer: 'Una marca del texto muestra el pasaje de su frase.',
      porte: 'Lo que lo sostiene',
      sansSource: 'Ninguna fuente citada para este argumento.',
      sansPassage: 'Ningún pasaje retenido de esta fuente.',
      ouvrir: 'Abrir la fuente',
      faits: 'Hechos establecidos sobre las mismas fuentes',
      sansFait: 'Ningún hecho establecido del análisis se apoya en estas fuentes.',
      nonConteste: 'No contestado',
      contestePar: { one: 'Contestado por {n} fuente', other: 'Contestado por {n} fuentes' },
      toutLeRecit: 'Para todo el relato',
    },
    relayeePar: 'Difundida por',
    construite: 'Cómo está construida esta lectura',
    perspectives: 'Las perspectivas',
    premium: 'Las perspectivas adicionales están reservadas a los suscriptores Premium',
    choisir: 'Elegir una perspectiva',
    precedent: 'Anterior',
    suivant: 'Siguiente',
  },

  typo: {
    ouvrant: '«',
    fermant: '»',
  },

  evolution: {
    importance: {
      major: 'Mayor',
      moderate: 'Moderado',
      minor: 'Menor',
    },
    issues: {
      confirmed: 'Confirmado',
      partially_confirmed: 'Confirmado en parte',
      invalidated: 'Invalidado',
      still_pending: 'Pendiente',
    },
    synthese: '◆ Síntesis de la evolución',
    perspectives: '⇄ Evolución de las perspectivas',
    aucunFait: 'Ningún hecho modificado documentado.',
    avant: 'Antes',
    maintenant: 'Ahora',
    aucunActeur: 'Ningún movimiento de actor documentado.',
    aucuneDonnee: 'No hay datos de perspectivas disponibles.',
    bilan: '◈ Balance de las perspectivas',
    bilanV: '◈ Balance de las perspectivas de la v{v}',
    depuis: '◈ Desde la v{v}: las perspectivas seguidas',
    depuisRien: 'Sin revisar desde la publicación.',
    etape: '{date}: {avant} % → {apres} %',
    inattendus: 'Acontecimientos inesperados',
    onglets: {
      synthese: 'Síntesis',
      faits: 'Hechos',
      acteurs: 'Actores',
      scenarios: 'Escenarios',
    },
  },

  faits: {
    certitude: 'Lo que se sabe con certeza',
    contestePlusieurs: 'Cuestionado en varios puntos',
    conteste: 'Cuestionado',
    fractures: 'Por qué nadie se pone de acuerdo',
    debatNeDitPas: 'Lo que el debate no dice',
    nbPerspectives: '{n} perspectivas sobre el mismo asunto',
    cliquez: 'Haga clic en una perspectiva para leer su análisis detallado',
    lirePerspective: 'Leer la perspectiva: {nom}',
    ceQuiSestPasse: 'Lo que ocurrió',
    pourAllerPlusLoin: 'Para ir más lejos',
  },

  subActeurs: {
    segments: {
      visibles: 'Visibles',
      caches: 'Ocultos',
      victimes: 'Víctimas',
    },
    aucun: { one: 'Se buscaron redes detrás del relato: no tiene ninguna.', other: 'Se buscaron redes detrás de los {n} relatos: ninguno tiene.' },
    tous: { one: 'Se buscaron redes detrás del relato: tiene.', other: 'Se buscaron redes detrás de los {n} relatos: todos tienen.' },
    partiel: 'Se buscaron redes detrás de los {n} relatos: {avec} tienen, {sans} ninguno. El detalle está en la pestaña Perspectivas, relato por relato.',
    discret: 'Discreto',
    victime: 'Víctima',
    agitPlus: 'Actúa más de lo que se ve · +{n}',
    influence: 'Influencia',
    visibilite: 'Visibilidad',
    retourActeurs: '← Volver a los actores',
    position: 'Posición en el asunto',
    etabli: 'Lo que está establecido',
    role: 'Función',
    indicateurs: 'Indicadores',
    titre: 'Actores',
    sousTitre: 'Visibles · Ocultos · Víctimas · Beneficiarios',
    typeActeurs: 'Tipo de actores',
    repartition: 'Lo que muestra este reparto',
    echelle: 'Influencia y visibilidad puntuadas sobre 100: la influencia es el peso en el curso de los hechos; la visibilidad, el espacio ocupado en el debate público.',
    dynamique: 'La dinámica de poder, en una lectura',
    cadrage: 'Quién controla el encuadre del debate',
  },

  sub: {
    chronologie: 'Cronología',
    nbEvenements: '{n} acontecimientos',
    peuConnus: ' · {n} poco conocidos',
    peuConnu: 'Poco conocido',
    historique: 'Profundidad histórica',
    precedents: '{n} precedentes que arrojan otra luz',
    similitudes: 'Similitudes',
    differences: 'Diferencias',
    lecons: 'Lecciones para el presente',
    benefice: 'Beneficio',
    impact: 'Impacto',
    impactNegatif: 'Impacto negativo',
    quoi: 'Lo que ocurrió',
    pourquoi: 'Por qué les afecta',
    auBout: 'En resumidas cuentas',
    tousProfils: '← Todos los perfiles',
    severite: 'Gravedad del impacto',
    pays: 'País',
    impactCitoyen: 'Impacto ciudadano',
    profilsDans: '{n} perfiles concretos en {pays} países',
    vueEnsemble: 'Panorama',
    plusTouche: 'Perfiles: del más afectado al menos afectado',
    lireHistoire: 'Leer su historia',
    plateformes: {
      autres: 'Otras plataformas',
    },
    ecart: {
      separees: 'Dos conversaciones separadas',
      differents: 'Encuadres claramente distintos',
      divergences: 'Algunas divergencias',
      proches: 'Encuadres cercanos',
    },
    reseaux: 'Lo que dicen las redes',
    ressentis: '{n} sentimientos dominantes',
    recitsEmergents: ' · {n} relatos emergentes',
    misesEnGarde: ' · {n} advertencias',
    ecartMedias: 'Brecha entre los medios y las redes: {ecart}/100 · {libelle}',
    ecartAria: 'Brecha de encuadre: {ecart} sobre 100',
    memesTermes: 'Mismos términos que los medios',
    domine: 'Lo que domina en línea',
    parts: 'Proporciones del sentimiento expresado en línea, tal como el análisis las reparte sobre 100.',
    presence: 'Presencia de cada sentimiento, medida por separado: estos valores no se reparten un total.',
    fausser: 'Lo que puede distorsionar estas señales',
    recitsMontent: '{n} relatos en alza',
    parPlateforme: 'Por plataforma: {liste}',
    scenariosPossibles: 'Escenarios posibles',
    scenariosSous: '{n} escenarios posibles · probabilidades estimadas · detonantes',
    declencheurs: 'Detonantes posibles',
    implications: 'Implicaciones',
    parProbabilite: 'Por probabilidad decreciente',
    sources: 'Fuentes',
    sourcesSous: '{n} fuentes · {cats} categorías · transparencia metodológica',
    categorieAria: 'Categoría de fuentes',
    corpus: '{n} fuentes · puntuación media {score}/10',
    duCorpus: ' · {part} del corpus',
    biaisEleveCertaines: ' · algunas fuentes de sesgo alto: ver detalle',
    contreCourant: 'A contracorriente',
    aucuneSource: 'Ninguna fuente en esta categoría.',
    limitesCorpus: 'Límites de este corpus',
  },

  sourcesCat: {
    primarySources: 'Fuentes primarias',
    mainstreamWestern: 'Medios occidentales dominantes',
    alternativeIndependent: 'Independiente / alternativo',
    nonWesternPerspectives: 'No occidental',
    academicWitnesses: 'Académico',
  },

  org: {
    portee: {
      global: 'Alcance mundial',
      regional: 'Alcance regional',
      national: 'Alcance nacional',
    },
    chargement: 'Cargando…',
    nonTrouvee: 'Organización no encontrada',
    retour: '← Volver a las organizaciones',
    organisations: 'Organizaciones',
    organisation: 'Organización',
    membresDocumentes: '{n} miembros documentados',
    dontBarometre: ' · {n} con un barómetro',
    fondeEn: 'Fundada en {date}',
    explorerReseau: 'Explorar su red en el grafo →',
    metaDescription: 'Think tanks, lobbies, fundaciones: cartografía de sus miembros, su financiación y sus objetivos reales.',
    metaIntrouvable: 'Organización no encontrada',
    metaProfil: '{type}: red de influencia, miembros y financiación analizados por Lumière Noire.',
    tiers: {
      S: 'Influencia máxima',
      A: 'Influencia mayor',
      B: 'Influencia significativa',
      C: 'Influencia moderada',
    },
    statutsMembre: {
      founder: 'Fundador',
      core_member: 'Miembro',
      alumni: 'Antiguo miembro',
      young_leader: 'Young Leader',
      invitee: 'Invitado',
      honorary: 'Honorario',
      emerging: 'Emergente',
      coopted_opponent: 'Opositor cooptado',
      emerging_leader: 'Líder emergente',
    },
    categories: {
      politicalLeaders: 'Política',
      corporateLeaders: 'Empresa',
      financialSector: 'Finanzas',
      mediaProfessionals: 'Medios',
      academicIntellectuals: 'Académico',
      militaryDefense: 'Defensa',
    },
    acces: {
      open: 'Abierto',
      restricted: 'Restringido',
      closed: 'Cerrado',
      chatham_house_rule: 'Regla de Chatham House',
    },
    q: {
      quoi: '¿Qué es?',
      quoiSous: 'Lo que dice de sí misma, lo que persigue, de dónde viene.',
      membres: '¿Quién forma parte?',
      membresSous: '{n} miembros documentados, por categoría; los invitados y los reclutas.',
      membresSousUn: '{n} miembro documentado, por categoría; los invitados y los reclutas.',
      membresSousVide: 'Los miembros documentados, los invitados y los reclutas.',
      influence: '¿Cómo influye en las decisiones?',
      influenceSous: 'Las recomendaciones que surtieron efecto, las crisis previstas, las citas.',
      argent: '¿De dónde viene el dinero?',
      argentSous: 'Quién la financia, cómo circula el dinero, los conflictos de intereses.',
      reseau: '¿Con quién trabaja?',
      reseauSous: 'Las organizaciones vinculadas, los miembros que comparten.',
      bilan: '¿Qué hay que retener?',
      bilanSous: 'Las constataciones, lo que plantea problemas, lo que es una contribución legítima.',
      ouvert: '¿Qué queda abierto?',
      ouvertSous: 'Lo que la ficha no pudo establecer, la fiabilidad de sus fuentes, las pistas de investigación.',
      sources: '¿En qué se basa?',
      sourcesSous: { one: '{n} fuente en el registro de la ficha.', other: '{n} fuentes en el registro de la ficha.' },
      rassemble: 'Esta pregunta reúne {liste}.',
      rassembleFace: 'Esta pregunta reúne {liste}, enfrentados.',
      rassembleReseau: 'Esta pregunta reúne {liste} y los miembros que comparten.',
      recommandations: { one: '{n} recomendación que surtió efecto', other: '{n} recomendaciones que surtieron efecto' },
      crises: { one: '{n} crisis prevista', other: '{n} crisis previstas' },
      evenements: { one: '{n} cita documentada', other: '{n} citas documentadas' },
      financements: { one: '{n} fuente de financiación', other: '{n} fuentes de financiación' },
      circuit: 'un circuito de financiación circular documentado',
      conflits: { one: '{n} conflicto de intereses documentado', other: '{n} conflictos de intereses documentados' },
      liens: { one: '{n} organización vinculada', other: '{n} organizaciones vinculadas' },
      constats: { one: '{n} constatación clave', other: '{n} constataciones clave' },
      problemes: { one: '{n} aspecto problemático', other: '{n} aspectos problemáticos' },
      contributions: { one: '{n} contribución legítima', other: '{n} contribuciones legítimas' },
      lesRendezVous: 'Las citas',
      essentiel: 'Lo esencial',
      sommaire: 'Índice de la ficha',
      enNQuestions: 'La ficha en {n} preguntas',
    },
  },

  menu3: {
    identite: 'Identidad',
    influence: 'Influencia',
    faits: 'Los hechos',
    contexte: 'El contexto',
  },

  orgSecteurs: {
    politicalLeaders: 'Política',
    corporateLeaders: 'Empresa',
    financialSector: 'Finanzas',
    mediaProfessionals: 'Medios',
    academicIntellectuals: 'Académico',
    internationalOrganizations: 'Org. int.',
    militaryDefense: 'Defensa',
  },

  orgMembres: {
    saFiche: 'Su ficha →',
    documentes: 'Documentados',
    politiques: 'Políticos',
    corporate: 'Empresa',
    finance: 'Finanzas',
    tauxPlacement: 'Tasa de colocación',
    delaiPosition: 'Plazo hasta el puesto',
    conversion: 'Conversión',
    notreLecture: '{libelle} (nuestra lectura)',
    chercher: 'Buscar un miembro…',
    categorie: 'Categoría',
    periode: 'Periodo',
    tous: 'Todos',
    enExercice: 'En activo',
    anciens: 'Antiguos',
    nbMembres: { one: '{n} miembro', other: '{n} miembros' },
    jusquEn: 'hasta {annee}',
    ancien: 'antiguo',
    invitesStrategiques: 'Invitados estratégicos',
    invite: 'Invitado',
    recruteEnsuite: 'reclutado después',
    nonRecrute: 'no reclutado',
    opposantsCooptes: 'Opositores cooptados',
    opposantCoopte: 'Opositor cooptado',
    positionInitiale: 'Posición inicial: {texte}',
    leadersEmergents: 'Líderes emergentes cultivados',
    leaderEmergent: 'Líder emergente',
  },

  orgEvents: {
    aucun: 'Ningún evento documentado',
    prochainRun: 'Los eventos estarán disponibles tras la próxima ejecución del pipeline.',
    documentesSur: 'Eventos documentados a lo largo de {n} años',
    documentes: 'Eventos documentados',
    avecParticipants: 'Con participantes identificados',
    fermees: 'Reuniones cerradas',
    dateInconnue: 'Fecha desconocida',
    sansEvenement: '{n} años sin eventos documentados',
    annees: 'Años {decennie}',
    voirEvenements: { one: 'Ver {n} evento más', other: 'Ver {n} eventos más' },
    dateIncertaine: 'Fecha incierta',
    nbParticipants: '{n} participantes',
    decisionsCorrelees: { one: '→ {n} decisión correlacionada', other: '→ {n} decisiones correlacionadas' },
    sujetsOfficiels: 'Temas oficiales',
    sujetsNonDivulgues: 'Temas no divulgados',
    participants: 'Participantes',
    nonConfirme: 'No confirmado',
    autres: { one: '+{n} más: ver el detalle →', other: '+{n} más: ver el detalle →' },
  },

  sourceRef: {
    retireeTitre: 'El enlace citado para esta entrada no correspondía a ningún formato de artículo válido del sitio invocado: se ha retirado. La pertenencia sigue mostrándose, pero ya no se apoya en nada.',
    atteste: 'Una fuente acredita esta pertenencia, pero no se puede citar ningún enlace preciso para esta entrada.',
    nonEtablieTitre: 'Ninguna fuente consultada acredita esta pertenencia. La entrada se conserva, pero no es verificable en su estado actual.',
    adresseRetiree: 'enlace retirado',
    attesteSansLien: 'acreditado, sin enlace',
    nonEtablie: 'fuente no establecida',
    pageAccueilTitre: '{url}: página de inicio del sitio: no documenta esta afirmación en particular.',
    pageAccueil: 'página de inicio',
    capture: 'Captura de archive.org',
    captureDisparue: ': la página original ya no responde (404)',
    voirPlus: 'Ver más →',
  },

  blocs: {
    nature: {
      faitEtLecture: 'Hecho y lectura',
      fait: 'Hecho',
      lecture: 'Lectura',
      methode: 'Método',
    },
    canaux: {
      titre: 'Los canales',
      sous: 'Por dónde pasa su influencia: las funciones oficiales, los enlaces informales, las idas y venidas de personas.',
      governmentCoordination: 'Ante los gobiernos',
      corporateCoordination: 'Ante las empresas',
      internationalCoordination: 'En el plano internacional',
      officialAdvisoryRoles: 'Funciones consultivas oficiales',
      informalInfluence: 'Influencia informal',
      revolvingDoor: 'Puertas giratorias',
      legislativeInfluence: 'Sobre la ley',
      ceoForums: 'Foros de directivos',
      industryAlignment: 'Alineamiento de los sectores',
      regulatoryCapture: 'Captura regulatoria',
      multilateralInfluence: 'Instituciones multilaterales',
      treatyInfluence: 'Tratados',
      globalGovernance: 'Gobernanza mundial',
    },
    argent: {
      titre: 'Adónde va el dinero',
      sous: 'Las grandes partidas de gasto, tal como están documentadas; los importes son los de las fuentes, a menudo redondeados.',
      total: 'Gasto total: {liste}',
      operational: 'Funcionamiento',
      programs: 'Programas',
      events: 'Eventos',
      lobbying: 'Lobbying',
    },
    reseau: {
      position: 'Su posición',
      positionSous: 'Lectura del mapa: dónde se sitúa, qué conecta.',
      coordination: 'Cómo se coordinan',
      coordinationSous: 'Lo que hace que estas organizaciones actúen juntas.',
      centralityScore: 'Su lugar en la red',
      clusterBelonging: 'Los círculos a los que pertenece',
      bridgingRole: 'Su papel de pasarela',
      redundancy: 'La redundancia de los vínculos',
      temporalCoordination: 'En el tiempo',
      thematicCoordination: 'Por los temas',
      personnelRotation: 'Por las personas',
      fundingCoordination: 'Por el dinero',
    },
    effets: {
      titre: 'Lo que produce',
      sous: 'Nuestra lectura de los efectos de su acción, a partir de los elementos con fuentes de la ficha.',
      economicImpact: 'Sobre la economía',
      socialImpact: 'Sobre la sociedad',
      sovereigntyImpact: 'Sobre la soberanía',
      democraticImpact: 'Sobre la democracia',
    },
    ouvert: {
      limites: 'Los límites de los datos',
      limitesSous: 'Lo que la ficha no pudo establecer, y por qué.',
      appui: 'En qué apoyarse',
      appuiSous: 'La evaluación que el análisis hace de sus propias fuentes.',
      pistes: 'Las pistas de investigación',
      pistesSous: 'Lo que habría que verificar, y que una ficha no puede zanjar por sí sola.',
      qualiteSources: 'Calidad de las fuentes',
      completude: 'Exhaustividad de los datos',
      risqueBiais: 'Riesgo de sesgo',
      niveau: {
        high: 'alto',
        medium: 'medio',
        low: 'bajo',
      },
      niveauF: {
        high: 'alta',
        medium: 'media',
        low: 'baja',
      },
      techniques: {
        sourceurl: 'Miembros sin enlace de fuente',
        urls: 'Entradas sin enlace de fuente',
        coopted: 'Opositores cooptados',
      },
    },
  },

  orgLibelles: {
    fonction: {
      network_coordination: 'coordinación de red',
      financial_coordination: 'coordinación financiera',
      policy_development: 'elaboración de políticas',
      talent_pipeline: 'cantera de dirigentes',
    },
    capture: {
      systematic: 'sistemática',
      significant: 'importante',
      moderate: 'moderada',
    },
    impact: {
      severe: 'grave',
      significant: 'importante',
      moderate: 'moderado',
    },
    portee: {
      global: 'mundial',
      regional: 'regional',
      national: 'nacional',
    },
    gravite: {
      critical: 'crítica',
      high: 'alta',
      medium: 'media',
      low: 'baja',
    },
    financement: {
      membership_fees: 'cuotas de los miembros',
      event_revenue: 'ingresos por eventos',
      foundation_grants: 'subvenciones de fundaciones',
      government_funding: 'financiación pública',
      corporate_partnerships: 'asociaciones empresariales',
      corporate_operations: 'actividad comercial',
      product_revenue: 'venta de productos',
    },
  },

  portrait: {
    mission: 'Misión oficial',
    objectifs: 'Objetivos reales',
    tauxPlacement: 'Tasa de colocación',
    orgsLiees: 'Org. vinculadas',
    conversion: 'Conversión',
    classification: 'CLASIFICACIÓN SISTÉMICA',
    fonction: 'Función',
    capture: 'Captura',
    impactDemocratique: 'Impacto democrático',
    portee: 'Alcance',
    phases: 'Fases de evolución',
    fondation: 'Fundación',
    expansion: 'Expansión',
    maturite: 'Madurez',
    contexteFondation: 'Contexto de la fundación',
    momentHistorique: 'Momento histórico',
    recitOfficiel: 'Relato oficial',
    motivations: 'Motivaciones reales',
    financementInitial: 'Financiación inicial',
    soutien: 'Apoyo institucional',
    fondateurs: 'Fundadores ({n})',
    fondateur: 'Fundador',
    reduire: 'Reducir ↑',
    details: 'Detalles →',
    motivationsAnalysees: 'Motivaciones analizadas',
    connexions: 'Conexiones de red',
    trajectoire: 'Trayectoria posterior',
    structure: 'Estructura organizativa',
    gouvernance: 'Gobernanza',
    criteres: 'CRITERIOS DE SELECCIÓN',
    categoriesMembres: 'CATEGORÍAS DE MIEMBROS',
    transparence: 'NIVEL DE TRANSPARENCIA',
    employes: 'Empleados',
    budget: 'Presupuesto anual',
  },

  duree: {
    immediat: 'inmediato',
    mois: { one: '{n} mes', other: '{n} meses' },
    ans: { one: '{n} año', other: '{n} años' },
    environAns: '~{n} años',
    jusqua: 'hasta {d}',
    entre: 'entre {a} y {b}',
  },

  panneau: {
    presse: {
      closed: 'a puerta cerrada',
      chatham_house_rule: 'regla de Chatham House',
      open: 'abierto a la prensa',
      partial: 'prensa admitida en parte',
    },
    source: 'Fuente',
    aQuitteEn: 'salió en {annee}',
    ancienMembre: 'antiguo miembro',
    inviteEn: 'invitado: {annee}',
    recruteEnsuite: 'reclutado después',
    nonRecrute: 'no reclutado',
    'cooptéEn': 'cooptado en {annee}',
    repereEn: 'detectado en {annee}',
    positionActuelle: 'Cargo actual',
    plusHautPoste: 'Cargo más alto',
    posteEntree: 'Cargo al ingresar',
    poste: 'Cargo',
    positionInitiale: 'Posición inicial',
    apresCooptation: 'Tras la cooptación',
    loyaute: 'Lealtad',
    anneeEntree: 'Año de ingreso',
    anneeSortie: 'Año de salida',
    alignement: 'Alineamiento político',
    decisionsCles: 'Decisiones clave',
    utilisationReseau: 'Uso de la red',
    contexteInvitation: 'Contexto de la invitación',
    gainOrganisation: 'Lo que gana la organización',
    relationEnsuite: 'Relación posterior',
    strategieCooptation: 'Estrategia de cooptación',
    neutralisation: 'Neutralización',
    strategieSuivi: 'Estrategia de seguimiento',
    placementObtenu: 'Colocación obtenida',
    description: 'Descripción',
    preuvesCoordination: 'Pruebas de coordinación',
    membresPartages: 'Miembros compartidos destacados',
    organisations: 'Organizaciones',
    fonctionPont: 'Función de puente',
    doubleAppartenance: 'Lo que le aporta la doble pertenencia',
    adoptee: 'adoptada',
    delaiImplementation: 'Plazo de aplicación',
    impactEconomique: 'Impacto económico',
    gouvernementsCibles: 'Gobiernos destinatarios',
    preuvesDocumentees: 'Pruebas documentadas',
    beneficiaires: 'Beneficiarios',
    alumniImplementeurs: 'Antiguos miembros que lo aplicaron',
    gravite: 'gravedad {niveau}',
    acteursImpliques: 'Actores implicados',
    preuves: 'Pruebas',
    premiereDiscussion: 'Primera discusión',
    criseRealisee: 'Crisis materializada',
    delaiAnticipation: 'Plazo de anticipación',
    mesuresPreparation: 'Medidas de preparación',
    nbParticipants: '{n} participantes',
    participants: 'Participantes ({n})',
    nonConfirme: 'no confirmado',
    decisionsCorrelees: 'Decisiones correlacionadas ({n})',
    pasCausalite: 'Correlación temporal documentada y con fuentes: no una causalidad establecida.',
    suiviImmediat: 'seguido inmediatamente',
    suiviApres: 'seguido {d} después',
  },

  orgOnglets: {
    deductionTitre: 'Deducción de Lumière Noire a partir de los elementos con fuentes de esta ficha: no es un hecho aportado por una fuente.',
    notreLecture: 'nuestra lectura',
    source: 'fuente ↗',
    recos: {
      transparencyMeasures: 'Medidas de transparencia',
      democraticSafeguards: 'Salvaguardas democráticas',
    },
    verdictSystemique: 'Veredicto sistémico',
    anomalies: 'Anomalías estadísticas',
    constatsCles: 'Constataciones clave',
    problematiques: 'Aspectos problemáticos',
    legitimes: 'Contribuciones legítimas',
    recommandations: 'Recomendaciones',
    gravite: 'gravedad {niveau}',
    sourcesFinancement: 'Fuentes de financiación',
    circulaire: 'Modelo de financiación circular',
    circuitCapture: 'Circuito de captura documentado',
    roi: 'Rentabilidad estimada',
    conflits: 'Conflictos de intereses ({n})',
    transparence: 'Transparencia',
    manquements: { one: '{n} incumplimiento documentado', other: '{n} incumplimientos documentados' },
    adopte: '✓ Adoptado',
    nonAdopte: 'No adoptado',
    recommandationsStat: 'Recomendaciones',
    tauxAdoption: 'Tasa de adopción',
    delaiMoyen: 'Plazo medio',
    penetrationGeo: 'Penetración geográfica',
    recosPolitiques: 'Recomendaciones políticas',
    anticipationCrises: 'Anticipación de crisis',
    orgLiee: 'Organización vinculada',
    nbOrganisations: '{n} organizaciones',
    orgsLiees: { one: '{n} organización vinculada', other: '{n} organizaciones vinculadas' },
    ecosysteme: 'Evaluación del ecosistema',
    organisationsLiees: 'Organizaciones vinculadas ({n})',
    laFiche: 'La ficha →',
    multiAffilies: 'Miembros con varias afiliaciones ({n})',
    multiAffiliesTexte: 'Personas presentes en varias organizaciones del ecosistema: los nodos de coordinación entre estructuras.',
    aucuneSource: 'Aún no hay fuentes documentadas para esta organización.',
    sourcesDocumentees: 'Fuentes documentadas',
    avecLien: '{n} fuentes · {liens} con enlace directo',
    tier: 'Nivel {tier}',
  },

  orgOrientation: {
    liens: {
      shared_members: 'miembros compartidos',
      funding: 'financiación',
      coordination: 'coordinación',
      ideological_alignment: 'alineamiento ideológico',
      subsidiary: 'filial',
      parent: 'matriz',
    },
    titre: 'Ficha de orientación: no es un análisis',
    etablissent: 'Lo que establecen {n} de nuestros análisis',
    sansAdresse: 'Esta mención no tiene ningún enlace de fuente.',
    personnes: 'Personas que nuestros análisis vinculan a {nom}',
    personnesTexte: 'Aparecen en nuestros análisis de otras organizaciones. No son necesariamente sus dirigentes, y la lista no es exhaustiva.',
    releveDans: 'registrado en nuestro análisis de',
    nePeutPas: 'Lo que esta ficha no puede decir',
    assemblee: 'Elaborada el {date} a partir de {mentions} mención(es) y {sources} fuente(s). Sin investigación propia, sin contenido generado.',
  },

  orgListe: {
    portees: {
      global: 'Global',
      regional: 'Regional',
      national: 'Nacional',
    },
    tous: 'Todos',
    toutes: 'Todas',
    kicker: 'Organizaciones · redes de influencia',
    orientations: { one: ' · {n} ficha de orientación', other: ' · {n} fichas de orientación' },
    titre: 'Los círculos del poder',
    analysees: { one: 'organización analizada', other: 'organizaciones analizadas' },
    recherche: 'Nombre, sigla, sede…',
    type: 'Tipo',
    portee: 'Alcance',
    analyseesDabord: 'Analizadas primero',
    plusMembres: 'Más miembros documentados',
    nomAZ: 'Nombre, de la A a la Z',
    aucune: 'Ninguna organización coincide',
    bientot: 'Las primeras organizaciones cartografiadas llegarán pronto.',
    bleuPortee: 'El azul sigue el alcance:',
    mondiale: 'mundial',
    regionale: 'regional',
    nationale: 'nacional',
    nonRenseignee: 'no indicado',
    membresDocumentes: 'miembros documentados',
    ficheOrientation: 'Ficha de orientación',
    citeePar: ' · citada por {noms}',
  },

  cumulards: {
    aria: 'Las personas presentes en varias organizaciones',
    titre: { one: '{n} persona en varias de estas organizaciones', other: '{n} personas en varias de estas organizaciones' },
    plusPresentes: ' · las {n} más presentes',
    nbOrganisations: '{n} organizaciones',
  },

  cartes: {
    ouvrir: '{nom}: abrir el detalle',
    detail: 'Detalle →',
  },

  enq: {
    nature: {
      lecture: 'Lectura',
      hypothese: 'Hipótesis',
      observation: 'Observación',
      fait: 'Hecho',
    },
    source: 'Fuente ↗',
    plusLoin: 'Para ir más lejos',
    statuts: {
      en_cours: 'Procedimiento en curso',
      classe: 'Archivada',
      close: 'Cerrada',
      condamnation: 'Condena',
      relaxe: 'Absolución',
      non_lieu: 'Sobreseimiento',
    },
    declare: 'Declarado',
    observe: 'Observado',
    estime: 'Estimado',
    ecart: 'Desfase',
    attendu: 'Esperado',
    intention: 'Intención',
    coincidence: 'Coincidencia',
    systeme: 'Sistema',
    q: {
      qui: '¿Quién es?',
      quiSous: 'La trayectoria, paso a paso.',
      justice: '¿Qué examina la justicia?',
      justiceSous: 'Los procedimientos documentados y su estado. Un procedimiento en curso no establece ninguna culpabilidad.',
      argent: '¿De dónde viene el dinero?',
      argentSous: 'Los flujos documentados, el patrimonio, los conflictos de intereses.',
      argentReserve: { one: '{n} flujo o conflicto de intereses documentado, el patrimonio declarado y estimado, el tren de vida.', other: '{n} flujos y conflictos de intereses documentados, el patrimonio declarado y estimado, el tren de vida.' },
      entourage: '¿Quién le rodea?',
      entourageSous: 'Los allegados, los aliados, las relaciones de negocios, de prensa y de influencia.',
      entourageReserve: { one: '{n} relación documentada: allegados, aliados políticos, negocios, medios, círculos de influencia.', other: '{n} relaciones documentadas: allegados, aliados políticos, negocios, medios, círculos de influencia.' },
      recit: '¿Quién cuenta su historia?',
      recitSous: 'La prensa que le respalda, lo que se amplifica, lo que desaparece.',
      recitReserve: { one: '{n} mecanismo o relato documentado: la prensa afín, los temas amplificados, los temas apartados.', other: '{n} mecanismos y relatos documentados: la prensa afín, los temas amplificados, los temas apartados.' },
      colle: '¿Qué es lo que no cuadra?',
      colleSous: 'Lo que se dijo y lo que se hizo; lo que se aparta de lo habitual.',
      colleReserve: { one: '{n} contradicción o desfase documentado, contrastado punto por punto.', other: '{n} contradicciones y desfases documentados, contrastados punto por punto.' },
      ouvert: '¿Qué queda abierto?',
      ouvertSous: 'Lo que la investigación no pudo zanjar, y lo que descartó.',
      ouvertReserve: { one: '{n} otra pregunta o rumor descartado, y los límites de la investigación.', other: '{n} otras preguntas y rumores descartados, y los límites de la investigación.' },
      sources: '¿En qué se basa?',
      sourcesSous: { one: '{n} fuente, en el orden en que la cita la investigación.', other: '{n} fuentes, en el orden en que las cita la investigación.' },
    },
    blocs: {
      formation: 'Formación',
      parcoursPrive: 'Trayectoria privada',
      chaqueEtape: 'Lo que la investigación señala en cada etapa',
      enquetesEnCours: 'Investigaciones en curso',
      recoupement: 'El cotejo, caso por caso',
      refutation: 'Elementos de refutación',
      conflits: 'Conflictos de intereses documentados',
      patrimoine: 'Patrimonio',
      transactions: 'Transacciones destacadas',
      construction: 'La construcción, periodo por periodo',
      trainDeVie: 'Tren de vida y bienes',
      premierCercle: 'El primer círculo',
      politique: 'En política',
      affaires: 'En los negocios',
      presse: 'En la prensa',
      international: 'En el plano internacional',
      cerclesInfluence: 'Círculos de influencia',
      liensInattendus: 'Vínculos inesperados',
      cercleRapproche: 'El círculo cercano, función oficial y función real',
      nominations: 'Cómo se hacen los nombramientos',
      protection: 'Protección institucional',
      opposants: 'Opositores',
      amplifie: 'Lo que se amplifica',
      disparait: 'Lo que desaparece',
      favorables: 'Medios descritos como favorables',
      critiques: 'Medios descritos como críticos',
      ordinaire: 'Lo que se aparta de lo habitual',
      schemas: 'Los patrones recurrentes y tres formas de leerlos',
      hypotheses: 'Hipótesis concurrentes',
      rumeursEcartees: 'Rumores descartados por falta de cotejo',
      manque: 'Lo que falta para zanjarlo',
      biais: 'Los posibles sesgos de esta investigación',
    },
    documentOfficiel: 'Documento oficial',
    essentiel: 'Lo esencial',
    sommaire: 'Índice de la investigación',
    enNQuestions: 'La investigación en {n} preguntas',
    legendeNatures: 'cada pasaje dice lo que es.',
    faitsDocumentes: { one: '{n} hecho documentado, contra la idea preconcebida.', other: '{n} hechos documentados, contra la idea preconcebida.' },
    page: {
      acteurNonTrouve: 'Actor no encontrado',
      introuvable: 'Investigación no encontrada',
      nonDisponibles: 'Datos no disponibles',
      retour: '← Volver a la ficha del actor',
      investigation: 'Investigación',
      kicker: 'Investigación · actualizada el {date}',
      procedures: { one: 'procedimiento judicial documentado', other: 'procedimientos judiciales documentados' },
    },
  },

  anatInv: {
    force: {
      strong: 'Fuerte',
      moderate: 'Moderado',
      weak: 'Débil',
    },
    certitude: {
      high: 'Certeza alta',
      medium: 'Certeza media',
      low: 'Certeza baja',
    },
    fiabilite: {
      high: 'Fiabilidad alta',
      medium: 'Fiabilidad media',
      low: 'Fiabilidad baja',
    },
    piste: {
      mechanism_to_expose: 'Mecanismo por exponer',
      relationship_to_document: 'Relación por documentar',
      fact_to_verify: 'Hecho por verificar',
      timeline_to_reconstruct: 'Cronología por reconstruir',
      actor_to_investigate: 'Actor por investigar',
    },
    priorite: {
      high: 'prioridad alta',
      medium: 'prioridad media',
      low: 'prioridad baja',
    },
    prioriteBrute: 'prioridad {p}',
    acteursCles: 'Actores clave',
    orgsCles: 'Organizaciones clave',
    aucunFait: 'Ningún hecho consolidado para este tema.',
    faitsPivots: { one: 'El hecho clave documentado que fundamenta la investigación.', other: 'Los {n} hechos clave documentados que fundamentan la investigación.' },
    aucunArgument: 'Ningún argumento disponible.',
    pour: 'A favor',
    contre: 'En contra',
    aucunPour: 'Ningún argumento a favor.',
    aucunContre: 'Ningún argumento en contra.',
    sourceFleche: 'Fuente →',
    aucunAngle: 'Ningún punto ciego identificado.',
    anglesIntro: 'Las zonas de sombra y las preguntas que deja abiertas el estado actual de la documentación.',
    aucuneChrono: 'Ningún dato cronológico ni pista identificados.',
    chronologie: 'Cronología ({n})',
    pistes: 'Pistas por explorar ({n})',
    pistesIntro: 'Lo que la investigación identifica como próximos ángulos de indagación.',
    faits: 'Hechos',
    arguments: 'Argumentos',
    anglesMorts: 'Puntos ciegos',
    chronoPistes: 'Cronología y pistas',
    pasDeDetail: 'Todavía no hay detalle documentado para este tema.',
    question: 'La pregunta planteada',
    conclut: 'Lo que concluye',
    appuie: 'Lo que la respalda',
    limite: 'Lo que la limita',
  },

  preuve: {
    P1: 'Hecho establecido',
    P2: 'Hecho probable',
    P3: 'Hipótesis fundamentada',
    P4: 'Hipótesis plausible',
    P5: 'Especulación',
  },

  anatQ: {
    certitude: {
      high: 'certeza alta',
      medium: 'certeza media',
      low: 'certeza baja',
      contested: 'certeza discutida',
    },
    implication: {
      structural: 'Estructural',
      political: 'Político',
      economic: 'Económico',
      social: 'Social',
    },
    essentiel: '¿Qué hay que retener?',
    essentielSous: 'Lo que la investigación afirma, lo que demuestra, lo que se desprende de ella.',
    affirme: 'Lo que se afirma',
    demontre: 'Lo que se demuestra · {n}',
    decoule: 'Lo que se desprende',
    enquetes: '¿Qué se ha investigado?',
    enquetesSous: { one: '{n} subinvestigación: la pregunta planteada, lo que concluye, los hechos y los argumentos.', other: '{n} subinvestigaciones: la pregunta planteada, lo que concluye, los hechos y los argumentos.' },
    enquetesReserve: { one: 'Esta pregunta reúne {n} subinvestigación, con su pregunta, su conclusión, sus hechos, sus argumentos y su cronología.', other: 'Esta pregunta reúne {n} subinvestigaciones, cada una con su pregunta, su conclusión, sus hechos, sus argumentos y su cronología.' },
    convergences: '¿Qué se repite en todas partes?',
    convergencesSous: 'Lo que las subinvestigaciones establecen juntas, y dónde se contradicen.',
    convergencesReserve: { one: 'Esta pregunta reúne {n} convergencia entre las subinvestigaciones, y sus contradicciones.', other: 'Esta pregunta reúne {n} convergencias entre las subinvestigaciones, y sus contradicciones.' },
    citoyens: '¿Cuánto les cuesta a los ciudadanos?',
    citoyensSous: 'La cifra clave, los órdenes de magnitud, los efectos directos.',
    citoyensReserve: 'Esta pregunta cifra lo que el sistema cuesta en concreto: la cifra clave, sus equivalencias, los efectos directos en los hogares.',
    acteurs: '¿Quién está implicado?',
    acteursSous: 'Los actores y las organizaciones, desde los que aparecen en todas partes hasta los de una sola subinvestigación.',
    acteursReserve: 'Esta pregunta reúne los actores y las organizaciones de las subinvestigaciones, ordenados por transversalidad.',
    ouvert: '¿Qué no se puede probar?',
    ouvertSous: 'Lo que las pruebas no permiten afirmar, y la pregunta que queda sin respuesta.',
    questionOuverte: 'La pregunta que sigue abierta',
    sources: '¿En qué se basa?',
    sourcesSous: { one: 'Los documentos en los que se apoya la subinvestigación.', other: 'Los documentos en los que se apoyan las {n} subinvestigaciones.' },
    sommaire: 'Índice de la anatomía',
    enNQuestions: 'La anatomía en {n} preguntas',
  },

  anatConv: {
    force: {
      strong: 'convergencia fuerte',
      moderate: 'convergencia moderada',
      weak: 'convergencia débil',
    },
    resolution: {
      resolved: 'Resuelta',
      partially_resolved: 'Parcialmente resuelta',
      non_resolved: 'No resuelta',
    },
    intro: 'Una convergencia es un mecanismo que aparece de forma independiente en varias subinvestigaciones: la señal de que es sistémico, no accidental.',
    titre: 'Convergencias · {n}',
    dontFortes: { one: ', de ellas {n} fuerte', other: ', de ellas {n} fuertes' },
    sousEnquetes: { one: '{n} subinvestigación', other: '{n} subinvestigaciones' },
    preuvesCles: 'Pruebas clave · {n}',
    source: 'Fuente →',
    rechercheComplementaire: 'Investigación complementaria',
    contradictions: 'Contradicciones · {n}',
    dontNonResolues: { one: ', de ellas {n} no resuelta', other: ', de ellas {n} no resueltas' },
    ouEnEst: 'En qué punto está la contradicción',
    concernees: 'Subinvestigaciones afectadas',
  },

  anatSrc: {
    fiab: {
      official: 'Documento oficial',
      high: 'Fiabilidad alta',
      medium: 'Fiabilidad media',
      moderate: 'Fiabilidad moderada',
    },
    court: {
      official: 'Oficial',
      high: 'Alta',
      medium: 'Media',
      moderate: 'Moderada',
    },
    aucune: 'No se ha registrado ninguna fuente para esta anatomía.',
    documents: { one: 'documento distinto', other: 'documentos distintos' },
    dont: 'de ellos',
    solides: { one: 'oficial o de fiabilidad alta', other: 'oficiales o de fiabilidad alta' },
    partagees: { one: 'citado por varios temas', other: 'citados por varios temas' },
    toutes: 'Todas',
    nonRenseignee: 'Fiabilidad no indicada',
    citePar: 'Citado por {n} temas',
  },

  anatCit: {
    echelle: {
      individual: 'Individual',
      household: 'Hogar',
      community: 'Comunidad',
      societal: 'Social',
    },
    chiffres: 'Cifras clave',
    directs: 'Impactos directos',
    indirects: 'Impactos indirectos',
    opportunite: 'Coste de oportunidad',
    geographie: 'Por región',
    aRetenir: 'La cifra clave',
    synthese: 'Síntesis',
  },

  anatEnt: {
    sousEnquetes: { one: '{n} subinvestigación', other: '{n} subinvestigaciones' },
    conflit: 'Conflicto de intereses',
    acteur: 'Actor',
    organisation: 'Organización',
    comptes: '{total} entidades registradas · {transversales} presentes en al menos dos subinvestigaciones',
    conflits: { one: ' · {n} conflicto de intereses señalado', other: ' · {n} conflictos de intereses señalados' },
    centraux: 'Presentes en tres o más subinvestigaciones · {n}',
    autresActeurs: 'Los demás actores · {n}',
    autresOrgs: 'Las demás organizaciones · {n}',
  },

  anatPage: {
    certitude: {
      high: 'Certeza alta',
      medium: 'Certeza media',
      low: 'Certeza baja',
      contested: 'Discutido',
      aucune: 'No evaluado',
    },
    anatomies: 'Anatomías',
    metaDescription: 'Expedientes de investigación en profundidad — temas, convergencias, actores y conclusiones sobre los asuntos que estructuran el mundo.',
    kicker: 'Anatomías · grandes expedientes transversales',
    titre: '¿Qué es lo que hace sistema?',
    grandsDossiers: { one: 'gran expediente', other: 'grandes expedientes' },
    intro: 'Una anatomía parte de un tema, lo abre en subinvestigaciones y busca lo que se repite de una a otra: los mismos nombres, los mismos mecanismos.',
    aucune: 'Todavía no hay ninguna anatomía',
    aucuneDesc: 'Las anatomías llegarán a medida que se publiquen.',
    themes: { one: 'tema', other: 'temas' },
    hautePriorite: ' · {n} de prioridad alta',
    convergences: { one: 'convergencia', other: 'convergencias' },
    erreurReseau: 'Error de red',
    chargement: 'Cargando la anatomía…',
    introuvable: 'Anatomía no encontrada',
    anatomie: 'Anatomía',
    grandDossier: 'Gran expediente',
    legende: { one: 'subinvestigaciones · {n} convergencia', other: 'subinvestigaciones · {n} convergencias' },
    quiTraverse: 'Quién atraviesa las {n} subinvestigaciones',
    pied: 'Lumière Noire · Anatomía · {date}',
    metaDefaut: 'Anatomía en profundidad — {n} temas investigados. Convergencias, actores y conclusiones por Lumière Noire.',
    ogSous: '{n} temas · Anatomía',
  },

  enqHub: {
    dossiers: {
      nom: 'Expedientes',
      accroche: 'Reunirlo todo',
      description: 'Investigaciones transversales que conectan análisis, investigaciones y despachos en torno a un tema o una entidad central.',
      voir: 'Ver los expedientes →',
    },
    anatomies: {
      nom: 'Anatomías',
      accroche: 'Diseccionar',
      description: 'Expedientes de investigación en profundidad — temas, convergencias, actores y conclusiones sobre los asuntos que estructuran el mundo.',
      voir: 'Ver las anatomías →',
    },
    loupes: {
      nom: 'Lupas',
      accroche: 'Señalar la anomalía',
      description: 'Anomalías factuales jerarquizadas sobre un tema de actualidad o de fondo. La Lupa plantea preguntas, no zanja.',
      voir: 'Ver las lupas →',
    },
    portee: {
      affair: 'Caso',
      period: 'Periodo',
      event: 'Acontecimiento',
    },
    bientot: 'Pronto, las primeras publicaciones.',
    titreDoc: 'Investigaciones — Lumière Noire',
    enquetes: 'Investigaciones',
    kicker: 'Investigaciones · formato largo',
    titre: '¿Qué hay detrás?',
    publiees: { one: 'investigación publicada', other: 'investigaciones publicadas' },
    intro: 'Nuestros formatos más exhaustivos, donde la actualidad ya ha pasado a otra cosa. Tres maneras de excavar: reunirlo todo, diseccionar un sistema o señalar una anomalía concreta.',
  },

  dosListe: {
    ancre: {
      actor: 'Actor',
      organization: 'Organización',
      thematic: 'Temático',
    },
    metaAnalyse: '✦ METAANÁLISIS',
    premium: '✦ Premium',
    stats: {
      analyses: { one: 'análisis', other: 'análisis' },
      investigations: { one: 'investigación', other: 'investigaciones' },
      bsScores: { one: 'BS', other: 'BS' },
      recentSignals: { one: 'despacho', other: 'despachos' },
    },
    tag: 'INTELIGENCIA EDITORIAL',
    titre: 'Expedientes',
    sousTitre: 'Investigaciones transversales que conectan análisis, investigaciones y despachos en torno a un tema o una entidad central.',
    publies: 'Expedientes publicados',
    avecMeta: 'Con metaanálisis',
    contenusLies: 'Contenidos vinculados',
    type: 'Tipo',
    tous: 'Todos',
    compte: { one: '{n} expediente', other: '{n} expedientes' },
    aucun: 'Ningún expediente publicado hoy',
    aucunType: 'Ningún expediente de tipo «{type}»',
    aucunDesc: 'Un expediente se construye sobre análisis ya publicados. Estamos rehaciendo ese material antes de escribir otros nuevos.',
  },

  dosFiche: {
    statut: {
      confirmed: 'Confirmado',
      invalidated: 'Invalidado',
      evolving: 'En evolución',
      pending: 'Pendiente',
    },
    confiance: {
      high: 'Fuerte',
      medium: 'Moderada',
      low: 'Débil',
    },
    gravite: {
      high: 'Crítica',
      medium: 'Moderada',
      low: 'Menor',
    },
    confianceRayon: {
      high: 'Confianza: Alta',
      medium: 'Confianza: Moderada',
      low: 'Confianza: Baja',
    },
    hypotheses: 'Hipótesis',
    contradictions: 'Contradicciones',
    noeuds: 'Nodos ocultos',
    perspectives: 'Perspectivas',
    anglesMorts: 'Puntos ciegos',
    metaAnalyse: 'Metaanálisis',
    sources: 'Fuentes:',
    acteur: 'Actor',
    organisation: 'Organización',
    hypotheseInitiale: 'Hipótesis inicial: {texte}',
    investigation: 'Investigación',
    contradictionPrincipale: 'Contradicción principal',
    apparaitDans: { one: 'Aparece en {n} análisis', other: 'Aparece en {n} análisis' },
    investigationComplete: '→ Investigación completa',
    coherence: '→ Coherencia',
    erreurChargement: 'Error de carga',
    chargement: 'Cargando el expediente…',
    introuvable: 'Expediente no encontrado',
    retour: '← Volver a los expedientes',
    syntheseMeta: '✦ Síntesis meta',
    introduction: 'Introducción',
    acteursOrgs: 'Actores y organizaciones',
    depechesRecentes: 'Despachos recientes',
    dossiers: 'Expedientes',
    metaDisponible: '✦ Metaanálisis disponible',
    baseSur: 'Basado en',
    analyses: 'Análisis',
    investigations: 'Investigaciones',
    analysesCoherence: 'Análisis de coherencia',
    misAJour: 'Actualizado el {date}',
    gate: 'Expediente completo reservado a los suscriptores Premium',
    metaPasGeneree: 'El metaanálisis de este expediente aún no se ha generado.',
    rayonsX: 'Rayos X vinculados',
    analysesAssociees: 'Análisis asociados',
    aucuneEntite: 'Ninguna entidad central identificada para este expediente.',
    orgsImpliquees: 'Organizaciones implicadas',
    aucuneDepeche: 'Ningún despacho reciente para este expediente.',
    filEditorial: 'Hilo editorial',
    conclusion: 'Conclusión editorial',
  },

  loupe: {
    gravite: {
      cosmetic: 'Cosmético',
      serious: 'Serio',
      structural: 'Estructural',
    },
    preuve: {
      established: 'Establecido',
      strongly_indicated: 'Fuertemente indicado',
      to_verify: 'Por verificar',
    },
    singularite: {
      banal: 'Banal',
      unusual: 'Inusual',
      highly_unusual: 'Muy inusual',
    },
    registre: {
      procedural: 'Procesal',
      mediatic: 'Mediático',
      biographic: 'Biográfico',
      financial: 'Financiero',
      behavioral: 'Conductual',
      institutional: 'Institucional',
    },
    plausible: 'Plausible',
    moinsPlausible: 'Menos plausible',
    evenement: {
      declaration: 'Declaración',
      procedural_act: 'Acto procesal',
      institutional_event: 'Acontecimiento institucional',
      media_event: 'Acontecimiento mediático',
      biographic_event: 'Acontecimiento biográfico',
      financial_flow: 'Flujo financiero',
      other: 'Otro',
    },
    phase: {
      procedural_act: 'Actos procesales',
      declaration: 'Declaraciones públicas',
      institutional_event: 'Acontecimientos institucionales',
      media_event: 'Cobertura mediática',
      biographic_event: 'Acontecimientos biográficos',
      financial_flow: 'Flujos financieros',
      other: 'Acontecimientos diversos',
    },
    aucunEvenement: 'No se ha situado ningún acontecimiento fechado en la cronología.',
    aucunExploitable: 'Ningún acontecimiento fechado utilizable.',
    chronoIntro: 'Los acontecimientos documentados por las anomalías del expediente, agrupados por año.',
    nEvenements: { one: '{n} acontecimiento', other: '{n} acontecimientos' },
    typeActeur: {
      person: 'Persona',
      organization: 'Organización',
      institution: 'Institución',
    },
    aucunActeur: 'Ningún actor identificado en este expediente.',
    acteursIntro: 'Las entidades identificadas en varias anomalías del expediente. Los pivotes reúnen sus principales relaciones documentadas.',
    pivots: 'Los pivotes del expediente',
    mentions: { one: 'mención', other: 'menciones' },
    nMentions: { one: '{n} mención', other: '{n} menciones' },
    autresRelations: { one: 'y {n} relación más', other: 'y {n} relaciones más' },
    autresActeurs: 'Los demás actores',
  },

  loupeB: {
    refermer: 'Cerrar ↑',
    plus: { one: '{n} fuente, preguntas e hipótesis ↓', other: '{n} fuentes, preguntas e hipótesis ↓' },
    aucuneAnomalie: 'Ninguna anomalía en este expediente.',
    registre: 'Registro',
    tous: 'Todos',
    tri: 'Orden',
    score: 'Puntuación',
    gravite: 'Gravedad',
    aucuneFiltre: 'Ninguna anomalía con este filtro. Pulse «Todos» para restablecer.',
    portee: {
      affair: 'Caso',
      period: 'Periodo',
      event: 'Acontecimiento',
    },
    loupe: 'Lupa',
    anomalies: { one: '{n} anomalía', other: '{n} anomalías' },
    structurelles: { one: ' · {n} estructural', other: ' · {n} estructurales' },
    sources: { one: ' · {n} fuente', other: ' · {n} fuentes' },
    leDossier: 'El expediente →',
    onglets: {
      saillantes: 'Destacadas',
      toutes: 'Todas',
      acteurs: 'Actores',
      chronologie: 'Cronología',
      nonaffirme: 'No afirmado',
    },
    leDossierAria: 'El expediente',
    aucuneSaillante: 'Ninguna anomalía supera el umbral de relevancia (puntuación compuesta ≥ {seuil}). Consulte la pestaña «Todas» para la lista completa.',
    saillantesIntro: 'Las {n} anomalías más destacadas del expediente, de {total} registradas.',
    sourcesN: 'Fuentes ({n})',
    questionsOuvertes: 'Preguntas abiertas',
    hypothesesPossibles: 'Hipótesis posibles',
    speculatives: 'Hipótesis especulativas — no demostradas',
    nonAffirme: 'No afirmado',
    aucunNonAffirme: 'Ninguna mención de conclusión no afirmada en este expediente.',
    nonAffirmeIntro: 'Este expediente enumera observaciones factuales sin concluir. Estas son las conclusiones que la lectura podría sugerir pero que este expediente se niega explícitamente a extraer.',
  },

  loupeP: {
    metaTitre: 'Lupa — Lumière Noire',
    metaDescription: 'Anomalías factuales jerarquizadas sobre temas de actualidad o de fondo. La Lupa plantea preguntas, no zanja.',
    enquetes: 'Investigaciones',
    loupe: 'Lupa',
    kicker: 'Lupa · anomalías factuales',
    titre: '¿Qué es lo que no cuadra?',
    legende: { one: 'anomalías registradas en {n} expediente', other: 'anomalías registradas en {n} expedientes' },
    intro: 'Los puntos de fricción documentables de un caso — judiciales, institucionales, procesales —, con fuentes y jerarquizados, sin conclusión sobre el fondo. La Lupa plantea preguntas, no zanja.',
    aucune: 'Todavía no hay ninguna Lupa',
    aucuneDesc: 'Las Lupas jerarquizan las anomalías factuales; las primeras llegarán pronto.',
    introuvable: 'Expediente no encontrado — Lumière Noire',
    metaFiche: 'Expediente Lupa: anomalías factuales jerarquizadas sobre «{sujet}». No se extrae ninguna conclusión.',
    dossier: 'Expediente',
    legendeFiche: { one: 'anomalías, de ellas {n} estructural', other: 'anomalías, de ellas {n} estructurales' },
    sourcesRegistres: { one: '{sources} fuentes · {n} registro', other: '{sources} fuentes · {n} registros' },
    publieLe: 'publicado el {date}',
    gate: 'Expediente Lupa reservado a los suscriptores Premium',
    construit: { one: 'Expediente construido a partir de {sources} fuentes web, {n} subpregunta de investigación.', other: 'Expediente construido a partir de {sources} fuentes web, {n} subpreguntas de investigación.' },
    publieLeMaj: 'Publicado el {date}.',
  },

  veille: {
    onglets: {
      all: 'Todo',
      analyses: 'Temas',
      acteurs: 'Actores',
      scenarios: 'Perspectivas',
    },
    importance: {
      critical: 'Crítico',
      high: 'Alto',
      medium: 'Medio',
      low: 'Bajo',
    },
    type: {
      micro_event: 'Microacontecimiento',
      major_evolution: 'Evolución importante',
      scenario_update: 'Perspectiva',
      contradiction: 'Contradicción',
      new_relationship: 'Nueva relación',
      obsolescence: 'Obsolescencia',
    },
    minutes: '{n}min',
    heures: '{n}h',
    jours: '{n}d',
    jour: {
      avenir: 'Próximamente',
      aujourdhui: 'Hoy',
      hier: 'Ayer',
      semaine: 'Esta semana',
      mois: 'Este mes',
      ancien: 'Más antiguo',
    },
    critique: 'Crítico',
    sources: 'Fuentes',
    badge: {
      actor: 'Actor',
      scenario: 'Perspectiva',
      analysis: 'Tema',
    },
    recents: { one: '{n} reciente', other: '{n} recientes' },
    critiques: { one: '{n} crítico', other: '{n} críticos' },
    voirFiche: 'Ver la ficha',
    depeches: { one: '{n} despacho', other: '{n} despachos' },
    titreDoc: 'Actualidad — Lumière Noire',
    plusDeSignaux: '{n} señales más · {reste} restantes',
    actualite: 'Actualidad',
    kickerDate: 'Vigilancia · último despacho el {date}',
    kicker: 'Vigilancia',
    titre: '¿Qué se ha movido?',
    legende: 'despachos en 30 días',
    dontCritiques: ' · de ellos {n} críticos',
    depechesOnglet: 'Despachos ({n})',
    entitesOnglet: 'Entidades ({n})',
    chargement: 'Cargando…',
    aucunResultat: 'Ningún resultado.',
    aucuneDepeche: 'Ningún despacho',
    rienFiltres: 'Nada coincide con los filtros activos.',
    tri: 'Orden',
    triRecents: 'Recientes',
    triVelocite: 'Velocidad',
    triCritiques: 'Críticos',
    rechercher: 'Buscar un tema…',
    type7: 'Tipo',
    periode: 'Periodo',
    j7: '7d',
    j30: '30d',
    tout: 'Todo',
    critiquesUniquement: 'Solo críticos',
    entites: { one: '{n} entidad', other: '{n} entidades' },
    filtreSur: 'Filtrado por',
    voirFicheFleche: 'Ver la ficha →',
    deselectionner: 'Deseleccionar',
    depechesTitre: 'Despachos',
    dernieres: 'Últimas noticias',
    aucunePourLeMoment: 'Ningún despacho por ahora',
    aucuneDesc: 'Ninguna noticia coincide con los filtros activos. Amplíe el periodo o la criticidad.',
  },

  veilleCat: {
    legal_action: 'Judicial',
    position_change: 'Reposicionamiento',
    media_appearance: 'Declaración',
    contradiction_with_known: 'Contradicción',
    position_vs_action: 'Discurso frente a hechos',
    unexpected_connection: 'Conexión',
    cross_pipeline: 'Cruce',
    temporal: 'Temporal',
    diplomatic: 'Diplomático',
    new_event: 'Acontecimiento',
  },

  veilleCarte: {
    maintenant: 'Está pasando ahora',
    toutVoir: 'Ver todo →',
    dernieres: 'Últimas noticias.',
    depeche: 'Despacho',
    voirFiche: 'Ver la ficha →',
    voir: 'Ver →',
    critique: 'Crítico',
    sources: 'Fuentes',
    replier: 'Plegar →',
    lire: 'Leer →',
    statut: {
      confirmed: 'confirmado',
      exploited: 'utilizado',
      detected: 'no verificado',
      dismissed: 'rechazado',
    },
    confianceFaible: 'confianza baja',
    confianceMoy: 'confianza media',
    voirFicheDe: 'Ver la ficha de {nom} →',
  },

  preds: {
    issue: {
      confirmed: 'Confirmado',
      partially_confirmed: 'Parcialmente',
      invalidated: 'Invalidado',
      pending: 'En curso',
    },
    retrospective: '✦ Retrospectiva',
    probaInitiale: 'Probabilidad inicial:',
    apercuAdmin: '(vista previa de administración — análisis no publicado)',
    predictionOrigine: 'Predicción original ↗',
    issueConstatee: 'Resultado constatado ↗',
    vous: 'Usted {n}%',
    nous: 'Nosotros {n}%',
    parier: 'Apostar — y luego ver nuestra estimación',
    connectez: 'Inicie sesión para apostar antes de ver nuestra estimación →',
    mouvement: 'Movimiento notable (+{n} pts)',
    echeance: '· Plazo {date}',
    voirAnalyse: 'Ver el análisis →',
    resolues: 'Resueltas',
    enCours: 'En curso',
    rechercher: 'Buscar un escenario…',
    aucunResultat: 'Ningún resultado',
    aucunResolu: 'Ningún escenario resuelto coincide con esta búsqueda.',
    aucunEnCours: 'Ningún escenario en curso coincide con esta búsqueda.',
    voirPlus: 'Ver {n} más',
    voitJuste: '¿Acertamos?',
    calibrationIntro: 'Cuando anunciamos una cifra, ¿se sostiene? En los escenarios ya resueltos, esta es la proporción que realmente se cumplió, según la probabilidad que habíamos anunciado al principio. Lo ideal: lo que damos al 80 % ocurre más a menudo que lo que damos al 20 %.',
    annonce: 'Anunciado {tranche}',
    deRealisation: 'de realización',
    volumeInsuffisant: 'volumen insuficiente',
    pasAssez: 'Todavía no hay suficientes escenarios resueltos para un balance fiable ({n} hasta la fecha) — vuelva dentro de unos meses.',
    publiees: 'Predicciones publicadas',
    confirmees: 'Confirmadas',
    partiellement: 'Parcialmente',
    invalidees: 'Invalidadas',
    predictions: 'Predicciones',
    tag: 'MEMORIA · PREDICCIONES',
    titre: 'Nuestras predicciones, verificadas',
    sousTitre: 'Publicamos escenarios fechados y cuantificados, y luego mostramos con honestidad en qué quedaron — aciertos y errores por igual.',
    methodo: 'Cada escenario se produce con una probabilidad inicial fechada y luego se vuelve a verificar periódicamente mediante nuestro proceso de seguimiento: la probabilidad evoluciona a medida que aparecen nuevos elementos, hasta un veredicto final (confirmado, parcialmente confirmado o invalidado).',
    voirMethodo: 'Ver la metodología completa →',
    aucunePubliee: 'Todavía no hay ninguna predicción publicada',
    aucunePublieeDesc: 'Los escenarios aparecerán aquí en cuanto un análisis publicado los contenga.',
  },

  pari: {
    erreurEnregistrement: 'No se ha podido registrar la apuesta.',
    erreurReseau: 'Error de red — vuelva a intentarlo.',
    echauffementTitre: 'Calentamiento · repita la historia',
    votrePari: 'Su apuesta',
    fermer: 'Cerrar',
    horizon: 'Horizonte: {texte}',
    echeance: 'Plazo: {date}',
    votreEstimation: 'Su estimación',
    deChances: 'de probabilidad de que este escenario se cumpla',
    estimationAria: 'Su estimación en porcentaje',
    impossible: 'Imposible',
    certain: 'Seguro',
    cachee: 'Nuestra estimación permanece oculta hasta que usted se compromete — eso es lo que hace honesta la apuesta.',
    engagerDecouvrir: 'Comprometerse y descubrir el resultado',
    engager: 'Confirmar mi apuesta',
    vousMieux: 'Usted acertó más que nosotros.',
    nousMieux: 'Esta vez acertamos más nosotros',
    egalite: 'Codo con codo',
    vous: 'Usted',
    nous: 'Nosotros',
    cePasse: 'Lo que ocurrió',
    votreScore: 'Su puntuación',
    leNotre: 'La nuestra',
    explicationScore: 'Su puntuación: cuanto más baja, más acertó. El calentamiento trata sobre escenarios ya conocidos — no cuenta en su balance real, solo sirve para practicar.',
    enregistre: 'Apuesta registrada. Sabremos quién tenía razón cuando se resuelva el escenario{echeance}. Su balance se actualizará automáticamente.',
    echeanceParenthese: ' (plazo {date})',
    continuer: 'Continuar',
    echauffement: 'Calentamiento',
    gammes: 'Haga sus ejercicios',
    gammesIntro: 'Apueste a ciegas sobre escenarios que la historia ya ha zanjado y descubra enseguida si acertó. Orientativo — no cuenta en su balance real, pero es la mejor manera de practicar.',
    parierAveugle: 'Apostar a ciegas →',
    dejaRejoues: 'Ya repetidos',
    vousN: 'Usted {n}%',
    nousN: 'Nosotros {n}%',
    voyezJuste: 'Y usted, ¿acierta?',
    surVosParis: { one: 'En su {n} apuesta en directo ya resuelta, esta es su puntuación frente a la nuestra, exactamente en el mismo escenario. Cuanto más baja, más acertó.', other: 'En sus {n} apuestas en directo ya resueltas, esta es su puntuación media frente a la nuestra, exactamente en los mismos escenarios. Cuanto más baja, más acertó.' },
    battez: 'Usted supera al modelo en este ámbito.',
    modeleAvantage: 'El modelo mantiene la ventaja — por ahora.',
    enAttente: { one: 'Tiene {n} apuesta en directo a la espera de veredicto. Su puntuación aparecerá aquí en cuanto se resuelva ese escenario.', other: 'Tiene {n} apuestas en directo a la espera de veredicto. Su puntuación aparecerá aquí en cuanto se resuelva uno de esos escenarios.' },
    echauffementIndicatif: 'Calentamiento (orientativo — escenarios ya conocidos)',
  },

  login: {
    enAttente: 'Su cuenta está pendiente de validación. Nos pondremos en contacto con usted en breve.',
    desactive: 'Esta cuenta ha sido desactivada. Póngase en contacto con el administrador.',
    tropTentatives: 'Demasiados intentos de conexión. Vuelva a intentarlo dentro de unos quince minutos.',
    incorrect: 'Correo electrónico o contraseña incorrectos.',
    erreurCreation: 'Error al crear la cuenta.',
    erreurReseau: 'Error de red.',
    devise: 'Comprender para no padecer.',
    promesse: 'Hechos con fuentes, contradicciones documentadas, redes cartografiadas. Sus conclusiones.',
    parolesTitre: 'Palabras y hechos',
    parolesTexte: 'los compromisos contrastados con los hechos',
    rayonxTexte: 'afirmaciones verificadas, con pruebas',
    reseauxTitre: 'Redes',
    reseauxTexte: 'quién está dónde, y cómo lo sabemos',
    inscription: 'Registro',
    connexion: 'Iniciar sesión',
    demandeEnregistree: 'Solicitud registrada',
    seraActive: 'Su cuenta se activará tras la validación. Nos pondremos en contacto con usted en cuanto esté abierta.',
    retourConnexion: 'Volver al inicio de sesión',
    bonRetour: 'Bienvenido de nuevo.',
    ouvrirCompte: 'Abrir una cuenta.',
    sousConnexion: 'Lo que sigue y lo que se ha movido desde su última visita.',
    sousInscription: 'Las cuentas se abren tras la validación: nos pondremos en contacto con usted.',
    nom: 'Nombre',
    votreNom: 'Su nombre',
    email: 'Correo electrónico',
    emailExemple: 'usted@email.com',
    motDePasse: 'Contraseña',
    verification: 'Verificando…',
    entrer: 'Entrar →',
    demanderCompte: 'Solicitar una cuenta →',
  },

  qg: {
    gratuit: 'Gratuito',
    monQg: 'Mi cuartel',
    titre: 'Lo que sigue, lo que se mueve.',
    elementsSuivis: { one: 'elemento seguido', other: 'elementos seguidos' },
    votes: { one: '{n} voto', other: '{n} votos' },
    groupes: { one: '{n} grupo', other: '{n} grupos' },
    intro: 'Sus análisis, actores y organizaciones guardados, y lo que se ha movido desde su última visita. Y los próximos temas: proponga, vote — los más votados se vuelven prioritarios.',
  },

  agora: {
    retirerVote: 'Retirar mi voto',
    voter: 'Votar',
    supprimerSuggestion: 'Eliminar mi sugerencia',
    confirmerSuppression: '¿Eliminar esta sugerencia? Esta acción es definitiva.',
    suppressionImpossible: 'Otras personas han votado por este tema: ya no se puede eliminar.',
    pipelineInconnu: 'Proceso no reconocido.',
    erreurStatut: 'Error {n}',
    pipelineLance: 'Proceso lanzado con éxito.',
    erreurReseau: 'Error de red, vuelva a intentarlo.',
    prochainsSujets: 'Los próximos temas',
    proposezVotez: 'Proponga y vote — los más votados pasan primero.',
    proposer: '+ Proponer',
    enCoursLancement: 'Proceso en marcha…',
    voirAnalyse: 'Ver el análisis →',
    affirmationAVerifier: 'Afirmación por verificar *',
    titreSujet: 'Título del tema *',
    pertinent: '¿Por qué es pertinente este tema?',
    region: 'Región',
    domaine: 'Ámbito',
    optGeo: 'Análisis geopolítico',
    optInvestigation: 'Investigación de actor',
    optBs: 'Coherencia de actor',
    optOrg: 'Investigación de organización',
    optRayonx: 'Afirmación al RayonX',
    annuler: 'Cancelar',
    envoi: 'Enviando...',
    soumettre: 'Enviar',
    lancement: 'Lanzando…',
    executer: 'Ejecutar ahora',
    aucuneProposition: 'Todavía no hay ninguna propuesta',
    soyezPremier: 'Sea el primero en proponer un tema',
    probables: 'Próximos temas probables',
    plusVotes: 'los más votados',
    mesPropositions: 'Mis propuestas',
    pasEncore: 'Todavía no ha propuesto ningún tema.',
    communaute: 'La comunidad propone',
  },

  portfolio: {
    titre: 'Lo que sigue',
    nouveautes: { one: '{n} novedad', other: '{n} novedades' },
    elements: { one: '{n} elemento', other: '{n} elementos' },
    tout: 'Todo',
    groupe: '+ Grupo',
    renommer: '✎ Renombrar el grupo',
    supprimer: '🗑 Eliminar',
    nomGroupe: 'Nombre del grupo...',
    creer: 'Crear',
    annuler: 'Cancelar',
    confirmerGroupe: '¿Eliminar este grupo? Los elementos guardados permanecerán en su portafolio sin grupo.',
    supprimerBtn: 'Eliminar',
    aucun: 'Ningún elemento guardado',
    aucunAide: 'Guarde análisis, actores y organizaciones con el botón 🔖 de sus páginas',
    voirVigie: 'Ver la vigilancia de este elemento',
    vigie: 'Vigilancia',
    deplacer: 'Mover',
    retirer: 'Quitar del portafolio',
    deplacerVers: 'Mover a',
    sansGroupe: 'Sin grupo',
  },

  vigie: {
    nouveau: 'Nuevo',
    critique: 'Crítico',
    maVigie: 'Mi vigilancia',
    depeches90: { one: '{n} despacho · últimos 90 días', other: '{n} despachos · últimos 90 días' },
    fermer: 'Cerrar',
    ficheComplete: 'Ver la ficha completa →',
    aucune: 'Ninguna noticia reciente sobre esta entidad.',
    voirPlus: { one: 'Ver más ({n} restante)', other: 'Ver más ({n} restantes)' },
  },

  graphe: {
    liens: {
      relationship: 'Relaciones',
      membership: 'Afiliaciones',
      co_membership: 'Copertenencias',
      org_link: 'Vínculos entre organizaciones',
      investigation: 'Investigaciones',
      event: 'Acontecimientos',
    },
    erreurChargement: 'Error de carga',
    aucunChemin: 'Ningún camino entre «{a}» y «{b}» en el grafo cargado. Despliegue primero otros nodos.',
    coSiege: '{n} personas coincidieron con este sujeto, en años que se solapan. ',
    coCran0: 'Se muestran los {montrees} vínculos más fuertes — pulse para ver los {n}.',
    coCran1: 'Se muestran las {n} — pulse para volver a las {plafond} más fuertes.',
    coCran2: 'Se muestran las {plafond} más fuertes — pulse para ocultarlas.',
    coCran3: 'Ocultas — pulse para volver a mostrarlas.',
    connexionsPremium: '{n} conexiones de investigación — Premium',
    membresNonAffiches: '+{n} miembros no mostrados',
    rechercher: 'Buscar una entidad…',
    depart: 'Pulse el nodo de partida',
    arrivee: 'Desde: {nom} → pulse el destino',
    chemin: 'Camino: {noeuds} nodos · {liens} vínculos',
    annuler: '✕ Cancelar',
    trouverChemin: '⇢ Buscar un camino',
    personne: 'Persona',
    organisation: 'Organización',
    sansFiche: 'Sin ficha',
    aide: 'Clic: detalles · Doble clic: desplegar · Rueda: zoom · Arrastrar: mover',
    construction: 'Construyendo el grafo…',
    fermer: 'Cerrar',
    acteur: 'Actor',
    entiteSansFiche: 'Entidad sin ficha',
    clique: ' · pulsado en el grafo',
    parolesActes: 'Palabras y hechos · {note}/10',
    investigation: 'Investigación',
    liensDansGraphe: 'Vínculos en el grafo',
    ficheComplete: 'Ver la ficha completa →',
    deployer: 'Desplegar la red',
    recentrer: 'Recentrar el grafo aquí',
    citeeSansFiche: 'Esta entidad aparece en una investigación pero aún no tiene ficha en la base.',
    leLien: 'El vínculo · {type}',
    // Textos construidos por /api/graph (13/10/2026).
    api: {
      relation: 'relación',
      membre: 'miembro',
      lien: 'vínculo',
      aSiegeAvec: 'coincidió con',
      cerclesCommuns: { one: '{n} círculo común', other: '{n} círculos comunes' },
      evenements: { one: '{n} evento', other: '{n} eventos' },
      presence: 'Presencia documentada — la más reciente: {nom}',
      membresPartages: { one: '{n} miembro compartido', other: '{n} miembros compartidos' },
      depuis: 'desde {annee}',
      enAnnee: 'en {annee}',
      enCours: 'actualidad',
      force: 'intensidad {n}/10',
    },
    force: 'fuerza {n}/10',
    etabli: 'Lo que está establecido',
    selonFiche: ' · según la ficha de {nom}',
    pasDescription: 'No hay descripción detallada de este vínculo.',
    source: 'Fuente',
    voirSource: 'Ver la fuente',
    socle: {
      organisations: 'Base de Lumière Noire (proceso de organizaciones).',
      investigation: 'Base de Lumière Noire (proceso de investigación).',
      veille: 'Base de Lumière Noire (proceso de vigilancia/análisis).',
    },
    titre: 'El Grafo',
    metaDescription: 'Quién está vinculado a quién y cómo lo sabemos — exploración interactiva de la red de influencia.',
    tag: 'RED · EXPLORACIÓN',
    sousTitre: 'Quién está vinculado a quién — y sobre todo, cómo lo sabemos. Cada vínculo se puede pulsar y muestra su fuente.',
    aucuneEntite: 'Todavía no hay ninguna entidad en la base.',
    provenance: 'Los vínculos proceden de la base de Lumière Noire: relaciones documentadas por la vigilancia y los análisis, afiliaciones a organizaciones, vínculos entre organizaciones y conexiones reveladas por las investigaciones (reservadas a los suscriptores). Pulse un vínculo para ver su justificación y su fuente.',
  },

  indicateur: {
    calcul: 'Cálculo',
    seuils: 'Umbrales',
    composantes: 'Componentes',
    limites: 'Límites',
    enSavoirPlus: 'Más información sobre {nom}',
  },

  rxPoints: {
    exact: 'Lo que es exacto',
    inexact: 'Lo que es inexacto o falta',
  },

  credits: {
    domainePublic: 'Dominio público',
    metaTitre: 'Créditos fotográficos — Lumière Noire',
    metaDescription: 'Autores y licencias de los retratos y logotipos que aparecen en Lumière Noire, procedentes de Wikimedia Commons y de Wikipedia.',
    fichier: 'archivo ↗',
    licence: 'licencia ↗',
    kicker: 'Información legal',
    titre: 'Créditos fotográficos',
    intro: 'Los {portraits} retratos y {logos} logotipos del sitio proceden de Wikimedia Commons y de Wikipedia. Cada uno lo publica su autor con la licencia indicada; los retratos pueden recortarse o mostrarse en bicromía. Un olvido, un error: la página Correcciones y derecho de réplica está para eso.',
    portraits: 'Retratos ({n})',
    logos: 'Logotipos ({n})',
  },

  page404: {
    titre: 'Página no encontrada',
    erreur: 'Error 404',
    rien: 'La luz no ha revelado nada aquí.',
    explication: 'Esta página no existe, o ya no existe. Puede que el enlace haya cambiado o que el contenido aún no se haya publicado. Retomemos la pista desde un punto seguro.',
    brief: 'El Brief del día →',
    accueil: 'Inicio',
    analyses: 'Análisis',
    chercherDesktop: '¿Busca algo concreto? Use la búsqueda',
    chercherMobile: '¿Busca algo concreto? Use la lupa de la parte superior de la página.',
  },

  site: {
    titreDefaut: 'Lumière Noire — Comprender para no padecer',
    description: 'Análisis geopolíticos independientes. Investigaciones, puntuaciones de coherencia, claves del poder real.',
  },

  apropos: {
    titre: 'Acerca de',
    metaDescription: 'Por qué existe Lumière Noire. La historia del proyecto, su misión y lo que lo distingue.',
    ogDescription: 'Entre los medios que repiten y los sitios que ven complots, faltaba un espacio riguroso.',
    devise: 'Comprender para no padecer.',
    chapo: 'Entre los medios que dan vueltas en bucle y los sitios que ven complots por todas partes, faltaba algo riguroso. Lumière Noire nació de esa frustración.',
    histoireTitre: 'Cómo empezó todo',
    histoire1: 'Antes del COVID, no seguía la actualidad de forma intensa. Como mucha gente, tuve miedo al principio de la pandemia y seguí las indicaciones de las autoridades. Era lo lógico.',
    histoire2: 'Luego llegó la variante Ómicron. Muy contagiosa, poco peligrosa. Pensé: perfecto — todos lo vamos a pillar, tendremos inmunidad, se levantarán las restricciones. Era la lógica sanitaria evidente.',
    histoire3: 'Fue entonces cuando se introdujo el pase sanitario. Contra toda lógica. Las indicaciones cambiaban cada día, en todos los sentidos, sin reconocer jamás el menor error. Los consejos científicos funcionaban en total opacidad. Los médicos que expresaban posiciones distintas eran sancionados o silenciados. Y los grandes medios lo repetían en bucle, sin ningún pensamiento crítico.',
    histoire4: 'Ese momento me abrió los ojos. No para empujarme hacia las teorías del complot — al contrario. Buscaba algo riguroso, con fuentes, mesurado. Algo que no tomara partido sino que documentara, cuestionara y se negara a enterrar los temas bajo la espuma de la siguiente noticia.',
    histoire5: 'También veía cómo nunca se exigía responsabilidad a los poderosos. Cómo los asuntos importantes se ahogaban en el flujo incesante de noticias. Cómo un tema que «debería haberlo cambiado todo» desaparecía en pocas semanas, sin continuidad, sin memoria.',
    histoire6: 'Lumière Noire nació de todo eso.',
    pasTitre: 'Lo que no somos',
    pasMainstream: 'No somos un medio convencional',
    pasMainstreamTexte: 'No repetimos los comunicados oficiales. No seguimos la moda de la actualidad. No damos vueltas en bucle.',
    pasComplot: 'No somos un sitio conspiranoico',
    pasComplotTexte: 'No hacemos revelaciones sin pruebas. No sacamos conclusiones más allá de lo que permiten las fuentes. Decimos «no lo sabemos» cuando no lo sabemos.',
    pasPartisan: 'No somos un órgano partidista',
    pasPartisanTexte: 'Analizamos los actos, no los bandos. Una puntuación de coherencia baja es una puntuación de coherencia baja, sea de izquierda o de derecha.',
    pasVerite: 'No es una verdad impuesta',
    pasVeriteTexte: 'Nuestro trabajo es darle los elementos. Las conclusiones son cosa suya.',
    faisonsTitre: 'Lo que hacemos',
    ecartsGras: 'Medimos la distancia entre los discursos y los hechos.',
    ecartsTexte: 'El análisis de coherencia documenta los compromisos públicos, los clasifica y los evalúa uno por uno con las fuentes. El resultado es una puntuación — pero sobre todo una lista de contradicciones documentadas.',
    memoireGras: 'Guardamos la memoria.',
    memoireTexte: 'La actualidad cuenta con su olvido. Lo que se dijo en 2019 y se contradijo en 2023 — lo encontramos, lo documentamos, lo relacionamos. Los hilos y los expedientes están para eso.',
    perspectivesGras: 'Construimos análisis desde varias perspectivas.',
    perspectivesTexte: 'En los temas geopolíticos complejos, no elegimos una interpretación ni enterramos las demás. Presentamos las hipótesis en competencia, sus argumentos, sus límites.',
    reseauxGras: 'Cartografiamos las redes.',
    reseauxTexte: 'Quién financia qué, quién conoce a quién, qué organizaciones influyen en qué decisiones — y a qué conduce en concreto.',
    projetTitre: 'Un proyecto independiente',
    projet1: 'Lumière Noire es un proyecto independiente, sin accionistas, sin anunciantes, sin línea editorial dictada por un financiador. Eso implica medios limitados — y por tanto decisiones: profundizar en lugar de acelerar, documentar en lugar de comentar.',
    projet2: 'Los análisis se elaboran con ayuda de la IA — no solo para tratar un volumen de datos que una persona sola no podría abarcar, sino por una razón más fundamental: evitar que los resultados se contaminen con mis emociones o mis convicciones personales. En temas políticos es difícil ser totalmente neutral. La IA no tiene opiniones sobre Macron o Mélenchon. Aplica el mismo protocolo a todo el mundo. Eso es lo que buscaba.',
    projet3: 'La misma lógica guía el sistema de votos y propuestas de temas. Si yo solo eligiera los actores y los temas analizados, la plataforma reflejaría inevitablemente mis intereses y mis puntos ciegos. Permitir que los usuarios propongan y voten es garantizar que Lumière Noire siga lo que a usted le preocupa — no lo que me preocupa a mí.',
    projet4: 'Cada resultado se controla, cada fuente se verifica, cada puntuación se justifica. Pero hacia dónde se mira no me pertenece solo a mí.',
    projet5: 'Si este proyecto le interesa, la mejor manera de apoyarlo es usarlo, hablar de él y, si lo desea, suscribirse para que podamos seguir haciéndolo existir.',
    explorer: 'Explorar la plataforma',
    explorerTexte: 'Acceso libre a los análisis, perfiles de actores, verificaciones de hechos y cartografías de organizaciones. Una cuenta gratuita desbloquea Mi cuartel: votos sobre los temas prioritarios, envío de propuestas, creación de carpetas y marcadores.',
    accueil: 'Inicio →',
    methodologie: 'Nuestra metodología',
  },

  couvEdito: {
    pageAccroche: 'Página de presentación',
    lire: 'Leer la página de presentación →',
    replier: '← Plegar',
  },

  qgLabels: {
    type: {
      actor: 'Actor',
      analysis: 'Análisis',
      organization: 'Organización',
      investigation: 'Investigación',
    },
    pipeline: {
      geo: 'Geopolítica',
      investigation: 'Investigación',
      bs: 'Análisis de coherencia',
      org: 'Organización',
      rayonx: 'RayonX',
    },
    statut: {
      pending: 'Pendiente',
      accepted: 'Aceptado',
      in_progress: 'En curso',
      published: 'Publicado',
      rejected: 'Rechazado',
    },
  },

  secteurs: {
    political: 'Política',
    corporate: 'Empresas',
    financial: 'Finanzas',
    media: 'Medios',
    academic: 'Universidad',
    internationalOrg: 'Org. internacionales',
    military: 'Ejército',
    autres: 'Otros',
  },

  historique: {
    create_position: 'Posición añadida a la ficha',
    create_flow: 'Flujo financiero documentado',
  },

  une: {
    titre: 'Lumière Noire – Comprender para no padecer',
    presentation: 'Lumière Noire confronta lo que dicen los responsables públicos con los hechos: promesas cumplidas o no, afirmaciones verificadas, escenarios de las crisis en curso, redes de influencia. Cada información remite a su fuente.',
    pourcent: '{p} %',
    glisser: 'deslizar',
    aucunePublication: 'Todavía no hay ninguna publicación.',
    contexte: 'Contexto',
    analyses: {
      titre: 'Análisis',
      texte: 'Lo que está establecido, lo que se discute, las perspectivas en competencia y los desenlaces probables.',
      toutes: { one: 'El análisis →', other: 'Los {n} análisis →' },
      miseAJour: 'Análisis · actualizado el {date}',
      publiee: 'Análisis · publicado el {date}',
      evolueLe: 'Lo que cambió el {date}',
      scenariosChiffres: 'Nuestros escenarios cuantificados, revisados cuando cambian los hechos.',
      plusProbable: 'El escenario más probable',
      plusProbableDeux: 'Escenario más probable:',
      dIciLe: ', de aquí al {date}',
      lesScenarios: 'Los escenarios →',
      lire: 'Leer el análisis →',
      etabli: 'Establecido',
      conteste: 'Discutido',
      perspectives: 'Las perspectivas en competencia',
      faits: { one: 'hecho establecido', other: 'hechos establecidos' },
      nPerspectives: { one: 'perspectiva', other: 'perspectivas' },
      sources: { one: 'fuente', other: 'fuentes' },
    },
    promesses: {
      titre: '¿Promesas cumplidas?',
      texte: 'Lo que dijeron, lo que hicieron.',
      tous: { one: 'El barómetro →', other: 'Los {n} barómetros →' },
      leBarometre: 'El barómetro →',
      voirTous: 'Ver los {n} compromisos →',
      voirTousUnParUn: 'Ver los {n} compromisos, uno por uno →',
      lesN: 'Los {n} compromisos →',
      misAJour: 'Actualizado el {date}',
      nonTenus: { one: 'incumplido', other: 'incumplidos' },
      partiels: { one: 'en parte', other: 'en parte' },
      tenus: { one: 'cumplido', other: 'cumplidos' },
      sansNote: 'sin evaluar',
      sansExecution: 'sin evaluar todavía',
    },
    bilan: {
      aucunNote: { one: '{n} compromiso, ninguno evaluado todavía frente a los hechos.', other: '{n} compromisos, ninguno evaluado todavía frente a los hechos.' },
      nonTenus: { one: '{n} compromiso de {total} incumplido', other: '{n} compromisos de {total} incumplidos' },
      partiels: '{n} en parte',
      aucunTenu: 'ninguno cumplido',
      tenus: { one: '{n} cumplido', other: '{n} cumplidos' },
      sans: '; {n} sin evaluar todavía',
      separateur: ', ',
      fin: '.',
    },
    depuis: {
      titre: 'Desde su última visita, el {date}',
      rien: 'Nada nuevo desde entonces: ninguna publicación, ningún escenario revisado, ningún despacho crítico.',
      parus: 'Publicado desde entonces · {n}',
      aEvolue: 'Cambió · {sujet}, el {date}',
      pourquoi: 'Por qué cambió →',
      critiques: { one: 'En la vigilancia · {n} crítico', other: 'En la vigilancia · {n} críticos' },
      veilleDepuis: 'La vigilancia desde el {date} →',
    },
    actualite: {
      titre: 'La actualidad',
      aVenir: 'Próximamente',
      derniersJours: 'Estos últimos días',
      toute: 'Toda la vigilancia →',
    },
    dernieresPublications: 'Últimas publicaciones',
    avis: {
      titre: '¿Usted qué opina?',
      vrai: 'Verdadero',
      faux: 'Falso',
      detail: 'El detalle →',
    },
    explorer: {
      titre: 'Explorarlo todo',
      promesses: {
        titre: '¿Promesas cumplidas?',
        texte: 'Lo que dijeron, lo que hicieron.',
        compte: { one: '{n} barómetro', other: '{n} barómetros' },
      },
      analyses: {
        titre: 'Análisis y escenarios',
        texte: 'Las crisis en curso y lo que puede ocurrir, cuantificado y revisado.',
        court: 'Las crisis en curso y lo que puede ocurrir.',
        compte: { one: '{n} análisis', other: '{n} análisis' },
      },
      rayonx: {
        titre: 'RayonX',
        texte: 'Una afirmación que circula, verificada frase por frase.',
        court: 'Una afirmación verificada frase por frase.',
        compte: { one: '{n} afirmación', other: '{n} afirmaciones' },
        tampon: '¿VERDAD?',
      },
      reseaux: {
        titre: 'Redes',
        texte: 'Quién se sienta dónde, quién financia a quién: vínculos fechados y con fuentes.',
        court: 'Quién se sienta dónde, quién financia a quién.',
        compte: '{acteurs} personalidades · {orgs} organizaciones',
      },
      enquetes: {
        titre: 'Investigaciones',
        texte: 'Los expedientes en los que profundizamos más allá de la actualidad.',
        court: 'Lupa, anatomías, investigaciones.',
        compte: 'Lupa, anatomías, investigaciones',
        derniereLoupe: 'Última Lupa: {titre}.',
      },
    },
  },

};
